import * as Yup from "yup";
import {
  Backdrop,
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Divider,
  InputAdornment,
  Grid,
  MenuItem,
  Stack,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
  IconButton,
} from "@mui/material";
import Select from "react-select";
import { Field, FieldArray, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { isEmpty } from 'lodash';
import {
  TerminalActions,
  getTerminalOptions,
  getTerminalDetails,
  Log,
  sendDataWithPost,
  sendDataWithGet,
} from "../../../services/services";
import { getCurrencyListByHost } from "../../../services/payment";
import MultiSelectField from "../../table/MultiSelectField";
import { AddCircleOutlined, Close, Visibility, VisibilityOff } from "@mui/icons-material";
import {
  showGrabPayDynamicField,
  showWorldPayDynamicField,
  showNomuPayDynamicField,
  showRazerDynamicField,
  showTouchNGoDynamicField,
  showDynamicField,
  showFiuuDynamicField,
  showFiuuFixedFeeDynamicField,
  showAllinpayDynamicField,
  showShopbackDynamicField,
  showNetsDynamicField,
  showHostFiuuDynamicField,
  showRevPayDynamicField,
  showCybersourceDynamicField,
  showDashDynamicField,
  showAliPayDynamicField,
  showAtomeDynamicField,
  showShopeePayMYDynamicField,
  showWeChatDynamicField,
  resetPaymentHostRateFields,
} from "../../../utils/terminal_dynamic_util";
import { MPI_TYPE_LIST, SUB_MERCHANT_COUNTRY_CODE, LIQUID_PAYEE_PREFIX, PAYMENT_HOST_LIST, MIN_AMOUNT_DEFAULT } from "../../../utils/constants";
import FormDialog from "../../FormDialog";
import { FormErrorScroll, toNumberInputString } from "../../../utils/appUtils";
import { styles } from "../../../utils/styles";
import { LoadingButton } from "@mui/lab";
import AllinpayFields from "../PaymentMethods/AllinpayFields";
import FiuuFixedFeeFields from "../PaymentMethods/FiuuFixedFeeFields";

const UnavailableOptionItem = <MenuItem disabled>Options unavailable</MenuItem>;
const transformEmptyToNull = (value, originalValue) => {
  if (originalValue === "" || originalValue === null || originalValue === undefined) {
    return null;
  }
  return Number.isNaN(value) ? null : value;
};

const EditDialog = ({ open, onClose, selectedId, setResponse, setLoaded }) => {
  const [terminalOptions, setTerminalOptions] = useState();
  const [terminalOptionsLoaded, setTerminalOptionsLoaded] = useState(false);
  const [terminalDetails, setTerminalDetails] = useState();
  const [terminalDetailsLoaded, setTerminalDetailsLoaded] = useState(false);
  const [route, setRoute] = useState();
  const [currencyByHost, setCurrencyByHost] = useState(null);
  const [paynowDescriptor, setPaynowDescriptor] = useState();
  const [mpiList, setMpiList] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState({});

  let paymentBrands = [];
  const [selectedPaymentBrands, setSelectedPaymentBrands] = useState([]);

  let paymentHosts = [];
  const [selectedPaymentHosts, setSelectedPaymentHosts] = useState([]);
  const [routeGw2, setRouteGw2] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [allowShowPassword, setAllowShowPassword] = useState(false);
  const [isLoadingGenerateOperatorPassowrd, setLoadingGenerateOperatorPassword] = useState(false);

  const initialRow = [
    {
      payment_method: "",
      payment_brand: "",
      payment_host: "",
      base_rate: "",
      markup_rate: "",
      base_rate_foreign: "",
      markup_rate_foreign: "",
      base_fix_fee_local: "0",
      markup_fix_fee_local: "0",
      base_fix_fee_foreign: "0",
      markup_fix_fee_foreign: "0",
      base_rate_installment: "",
      markup_rate_installment: "",
      credit_base_rate: "",
      credit_markup_rate: "",
      spaylater_base_rate: "",
      spaylater_markup_rate: "",
      shopeepay_credit_enabled: false,
      shopeepay_spaylater_enabled: false,
      shopeepay_wallet_enabled: false,
      merchant_ext_id: "",
      store_ext_id: "",
      is_shopeepay_brand: false,
      action: "Add",
      grabpay_merchant_id: "",
      grabpay_terminal_id: "",
      payment_expiry_time: "",
      postpaid: false,
      installment_4: false,
      min_amt_postpaid: "",
      min_amt_installment_4: "",
      pf_id: "",
      sub_name: "",
      sub_id: "",
      sub_street: "",
      sub_city: "",
      sub_country_code: "",
      sub_postal_code: "",
      mcc: "",
      enable_vis: false,
      currency_list: [],
      enabled_3ds: false,
      default_bin_routing: true,
      partner_merchant_reference_id: "",
      min_card_range: "",
      max_card_range: "",
      processing_account_id: "",
      secret_key: "",
      verification_key: "",
      merchant_id: "",
      channel: "",
      touchngo_expiry_time: "",
      touchngo_merchant_id: "",
      touchngo_client_id: "",
      touchngo_client_secret: "",
      is_autodebit_enabled: "",
      autodebit_amount: "",
      route_enabled: false,
      gw2_params: {
        mcptid: "",
        etype: ""
      },
      paynow_descriptor_id: "",
      ref_2: "",
      payee: "",
      line_pay_merchant_id: "",
      store_id: "",
      sub_mid: "",
      atome_username: "",
      atome_password: "",
      partner_id: "",
      allinpay_partner_id: "",
      allinpay_base_rate_local: "",
      allinpay_markup_rate_local: "",
      allinpay_base_rate_foreign: "",
      allinpay_markup_rate_foreign: "",
      mpi_type: 0,
      mpi_id: "",
      action_message: "",
      terminal_id: "",
      access_key_id: "",
      access_key_secret: "",
      pos_id: "",
      secret_id: "",
      key_id: "",
      mid: "",
      tid: "",
      institution_code: "",
      condition_code: "",
      host_fiuu_mid: "",
      host_fiuu_verify_key: "",
      host_fiuu_secret_key: "",
      cybs_merchant_id: "",
      cybs_merchant_keyid: "",
      cybs_merchant_secretkey: "",
      cybs_mpi_type: 0,
      ipp_enabled: false,
      ipp_plans: [],
      acquiring_institution_id: "",
      forwarding_institution_id: "",
      acceptor_id: "",
      processing_code: "",
      dci_descriptor: "",
      revpay_merchant_id: "",
      vis_dynamic_info_id: "",
      suspended: false,
      my_merchant_ext_id: "",
      my_store_ext_id: "",
      convenience_fee_indicator: "",
      convenience_fee_fixed: "",
      convenience_fee_percentage: "",
    },
  ];

  const clearedPaymentRow = () =>
    Object.entries(initialRow[0]).reduce((acc, [key, value]) => {
      if (typeof value === "string") acc[key] = "";
      else if (Array.isArray(value)) acc[key] = [];
      else if (value && typeof value === "object") acc[key] = { ...value };
      else acc[key] = value;
      return acc;
    }, {});

  const resetPaymentRowOnHostChange = (row, hostId) => ({
    ...row,
    ...clearedPaymentRow(),
    payment_method: row.payment_method,
    payment_brand: row.payment_brand,
    payment_host: hostId,
    currency_list: row.currency_list ?? [],
    is_shopeepay_brand: row.is_shopeepay_brand,
    shopeepay_wallet_enabled: row.is_shopeepay_brand,
    action: row.action,
    suspended: row.suspended,
  });

  const findPossibleBrands = (method) => {
    if (!terminalOptions) return UnavailableOptionItem;
    if (method !== "") {
      let brands = terminalOptions.find((e) => e.id === method);
      if (brands) {
        paymentBrands = paymentBrands.concat(
          brands.payment_brand_payment_method
        );

        brands = brands.payment_brand_payment_method;
      } else {
        return UnavailableOptionItem;
      }

      let brandList = brands.map((brand) => (
        <MenuItem key={brand.id} value={brand.id}>
          {brand.name}
        </MenuItem>
      ));
      return brandList.length > 0 ? brandList : UnavailableOptionItem;
    }

    return UnavailableOptionItem;
  };

  const findPossibleHosts = (method, brand) => {
    if (method === "" && brand === "") return UnavailableOptionItem;
    let brands = terminalOptions?.find(
      (e) => e.id === method
    )?.payment_brand_payment_method;

    if (!brands) return UnavailableOptionItem;

    let hosts = brands.find((e) => e.id === brand);

    if (hosts) {
      paymentHosts = paymentHosts.concat(hosts.payment_host_payment_brand);
      const hostList = hosts.payment_host_payment_brand.map((host) => (
        <MenuItem key={host.id} value={host.id}>
          {host.name}
        </MenuItem>
      ));

      return hostList.length > 0 ? hostList : UnavailableOptionItem;
    }

    return UnavailableOptionItem;
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    let list = [];
    values.payment.forEach((p) => {
      list.push(p);
    });

    list.forEach((value, index) => {
      const default_bin_routing = value["default_bin_routing"];
      const min_card_range = value["min_card_range"];
      const max_card_range = value["max_card_range"];
      const isTouchNGo = selectedPaymentHosts[index].includes(PAYMENT_HOST_LIST.TOUCHNGO);
      const isShopeePayMY = showShopeePayMYDynamicField(selectedPaymentHosts[index]);

      delete value["payment_charges_payment_mapping"];
      delete value["dynamic_info"];

      const isGrabPayV1 = selectedPaymentHosts[index]
        ?.toLowerCase()
        .includes(PAYMENT_HOST_LIST.GRABPAY_V1);

      if (!selectedPaymentHosts[index].includes(PAYMENT_HOST_LIST.GRABPAY)) {
        delete value["grabpay_merchant_id"];
        delete value["grabpay_terminal_id"];
        delete value["payment_expiry_time"];
        delete value["postpaid"];
        delete value["installment_4"];
        delete value["min_amt_postpaid"];
        delete value["min_amt_installment_4"];
      }

      if (isGrabPayV1) {
        // GRABPAY_V1 only uses these 2 fields
        delete value["payment_expiry_time"];
        delete value["postpaid"];
        delete value["installment_4"];
        delete value["min_amt_postpaid"];
        delete value["min_amt_installment_4"];
      }
      if (!selectedPaymentHosts[index].includes(PAYMENT_HOST_LIST.WORLDPAY)) {
        delete value["pf_id"];
        delete value["sub_name"];
        delete value["sub_id"];
        delete value["sub_city"];
        delete value["sub_country_code"];
        delete value["sub_postal_code"];
        delete value["mcc"];
        delete value["enable_vis"];
        delete value["default_bin_routing"];
        delete value["partner_merchant_reference_id"];
        // delete value["currency_list"];
        delete value["enabled_3ds"];
        delete value["min_card_range"];
        delete value["max_card_range"];
      }

      if (!selectedPaymentHosts[index].includes(PAYMENT_HOST_LIST.NOMU)) {
        delete value["min_card_range"];
        delete value["max_card_range"];
        delete value["processing_account_id"];
      }
      if (selectedPaymentHosts[index]?.toLowerCase().includes(PAYMENT_HOST_LIST.NOMU)) {
        value["min_card_range"] = min_card_range;
        value["max_card_range"] = max_card_range;
        value["default_bin_routing"] = default_bin_routing;
      }

      if (!showDashDynamicField(selectedPaymentHosts[index])) {
        delete value["counter_id"];
        delete value["counter_msisdn"];
        delete value["counter_pin"];
      }
      if (!showAliPayDynamicField(selectedPaymentHosts[index])) {
        delete value["store_id"];
      }

      if (!showAtomeDynamicField(selectedPaymentHosts[index])) {
        delete value["atome_username"];
        delete value["atome_password"];
        delete value["username"];
        delete value["password"];
      } else {
        value["username"] = value["atome_username"] ?? "";
        value["password"] = value["atome_password"] ?? "";
        delete value["atome_username"];
        delete value["atome_password"];
      }
      if (!showWeChatDynamicField(selectedPaymentHosts[index])) {
        delete value["partner_id"];
      }
      if (!showAllinpayDynamicField(selectedPaymentHosts[index])) {
        delete value["allinpay_partner_id"];
        delete value["allinpay_base_rate_local"];
        delete value["allinpay_markup_rate_local"];
        delete value["allinpay_base_rate_foreign"];
        delete value["allinpay_markup_rate_foreign"];
      } else {
        delete value["base_rate"];
        delete value["markup_rate"];
      }
      if (!selectedPaymentHosts[index].includes(PAYMENT_HOST_LIST.REVPAY)) {
        delete value["revpay_merchant_id"];
      }

      if (!isTouchNGo) {
        delete value["touchngo_expiry_time"];
        delete value["touchngo_merchant_id"];
        delete value["touchngo_client_id"];
        delete value["touchngo_client_secret"];
      }

      if (!isTouchNGo && !isShopeePayMY) {
        delete value["is_autodebit_enabled"];
        delete value["autodebit_amount"];
      }

      if (!isShopeePayMY) {
        delete value["convenience_fee_indicator"];
        delete value["convenience_fee_fixed"];
        delete value["convenience_fee_percentage"];
        delete value["my_merchant_ext_id"];
        delete value["my_store_ext_id"];
      }

      if (!showCybersourceDynamicField(selectedPaymentHosts[index])) {
        delete value["cybs_merchant_id"];
        delete value["cybs_merchant_keyid"];
        delete value["cybs_merchant_secretkey"];
        delete value["cybs_mpi_type"];
        delete value["ipp_enabled"];
        delete value["ipp_plans"];
      } else {
        // Keep update payload aligned with add behavior:
        // for Cybersource, prioritize cybs_mpi_type for mpi_type.
        if (value["cybs_mpi_type"] !== undefined && value["cybs_mpi_type"] !== null) {
          value["mpi_type"] = Number(value["cybs_mpi_type"]);
        }
        // If IPP is disabled, clear the plans
        if (!value["ipp_enabled"]) {
          delete value["ipp_plans"];
        }
      }

      if (!value.is_shopeepay_brand) {
        delete value["credit_base_rate"];
        delete value["credit_markup_rate"];
        delete value["spaylater_base_rate"];
        delete value["spaylater_markup_rate"];
        delete value["merchant_ext_id"];
        delete value["store_ext_id"];
      } else {
        // For ShopeePay: wallet rates use base_rate/markup_rate directly
        // credit and spaylater rates go to ShopeePayHostDynamicInfoPending
        if (!value.shopeepay_credit_enabled) {
          delete value["credit_base_rate"];
          delete value["credit_markup_rate"];
        }

        if (!value.shopeepay_spaylater_enabled) {
          delete value["spaylater_base_rate"];
          delete value["spaylater_markup_rate"];
        }

        // Wallet is always enabled for ShopeePay, so base_rate and markup_rate are always required
      }

      delete value["is_shopeepay_brand"];
      delete value["shopeepay_credit_enabled"];
      delete value["shopeepay_spaylater_enabled"];
      delete value["shopeepay_wallet_enabled"];

    });
    let map = {
      businessEntity: values.businessEntity,
      merchant: values.merchant,
      terminal_id: values.terminal_id,
      pk: terminalDetails.id,
      payment: list,
      mode: terminalDetails.mode?.id,
      operator_id: values.operator_id,
      operator_password: values.operator_password,
    };
    Log.info(`Click button [Submit] - Update Terminal details by Id: ${terminalDetails.id}`, map)
    try {
      await TerminalActions("update", map, onClose);
    } catch (error) {

    } finally {
      setSubmitting(false);
    }
  };

  const handleGenerateOperatorPassword = (cb) => {
    setLoadingGenerateOperatorPassword(true);
    const url = "/merchant/pending_terminal/generate_operator_password/";
    sendDataWithPost(url, {}, cb, () => { setAllowShowPassword(true); setLoadingGenerateOperatorPassword(false) });
  }

  useEffect(() => {
    const url = "/merchant/paynow_descriptor_v2/filter/";
    sendDataWithPost(url, {
      no_pagination: true,
      status: 'PASS'
    }, data => {
      const list = Array.isArray(data) ? data : (data?.results ?? []);
      const groupedData = list.reduce((acc, item) => {
        const hostName = item.payment_host.name.toLowerCase();
        // const status = item.status.toLowerCase();

        if ([PAYMENT_HOST_LIST.DBS, PAYMENT_HOST_LIST.SCB].includes(hostName?.toLowerCase())) {
          acc[hostName] = acc[hostName] || [];
          acc[hostName].push({
            id: item.id,
            name: item.is_custom ? item.party_name : item.merchant_name,
            paynow_proxy_suffix: item.paynow_proxy_suffix
          });
        }
        return acc;
      }, {});

      setPaynowDescriptor(groupedData);
    });
  }, [])

  useEffect(() => {
    const url = "/mpi_details/list/";
    sendDataWithGet(url, setMpiList);
  }, [])

  useEffect(() => {
    getTerminalOptions(setTerminalOptions, setTerminalOptionsLoaded);
    getTerminalDetails(
      selectedId,
      (res) => {
        const paymentHostIds = res.payment_mapping_terminal?.map(item => item.payment_host?.id);
        getCurrencyListByHost(
          {
            payment_host_ids: paymentHostIds,
          },
          (data) => {
            const list = Array.isArray(data) ? data : (data?.results ?? []);
            const result = list.reduce((acc, item) => {
              acc[item.id] = item;
              return acc;
            }, {});

            setCurrencyByHost(result)
          }
        );
        setTerminalDetails(res);
      },
      setTerminalDetailsLoaded,
      onClose
    );
  }, [selectedId]);

  useEffect(() => {
    if (terminalDetailsLoaded && terminalDetails) {
      const initialRow = [];
      let pList = [];
      let bList = [];
      let routeGw2Obj = {};
      let paymentMethodObj = {};
      terminalDetails.payment_mapping_terminal.forEach((route, index) => {
        if (route.is_active) {
          pList.push(route.payment_host?.name.toLocaleLowerCase());
          bList.push(route.payment_brand?.name.toLocaleLowerCase());

          let payment = {
            ...route,
            ...route.payment_charges_payment_mapping[0],
          };

          if (route.payment_charges_payment_mapping[0]) {
            for (const [key, value] of Object.entries(
              route.payment_charges_payment_mapping[0]
            )) {
              payment[key] = toNumberInputString(value);
            }
          }

          payment["payment_method"] =
            route.payment_method && route.payment_method.id;
          payment["payment_brand"] =
            route.payment_brand && route.payment_brand.id;
          payment["payment_host"] = route.payment_host && route.payment_host.id;
          payment["action"] = "update";
          payment["suspended"] = route.is_suspended;
          payment["pk"] = route.id;

          // Check if ShopeePay brand
          const brandName = route.payment_brand?.name?.toLocaleLowerCase() || "";
          const isShopeeBrand = brandName === PAYMENT_HOST_LIST.SHOPEEPAY;
          const isShopeePaySGOrTHHost = route.payment_host?.name?.toLocaleLowerCase() === PAYMENT_HOST_LIST.SHOPEEPAY_SG?.toLowerCase() || route.payment_host?.name?.toLocaleLowerCase() === PAYMENT_HOST_LIST.SHOPEEPAY_TH?.toLowerCase();
          payment["is_shopeepay_brand"] = isShopeeBrand;
          payment["shopeepay_wallet_enabled"] = isShopeeBrand; // Wallet always enabled for ShopeePay

          // Load ShopeePay rates from dynamic_info
          if (isShopeeBrand && isShopeePaySGOrTHHost && route.dynamic_info) {
            payment["shopeepay_credit_enabled"] = !!(route.dynamic_info.credit_base_rate || route.dynamic_info.credit_markup_rate);
            payment["shopeepay_spaylater_enabled"] = !!(route.dynamic_info.spaylater_base_rate || route.dynamic_info.spaylater_markup_rate);
            payment["credit_base_rate"] = route.dynamic_info.credit_base_rate || "";
            payment["credit_markup_rate"] = route.dynamic_info.credit_markup_rate || "";
            payment["spaylater_base_rate"] = route.dynamic_info.spaylater_base_rate || "";
            payment["spaylater_markup_rate"] = route.dynamic_info.spaylater_markup_rate || "";
            payment["merchant_ext_id"] = route.dynamic_info.merchant_ext_id || "";
            payment["store_ext_id"] = route.dynamic_info.store_ext_id || "";
          } else {
            payment["shopeepay_credit_enabled"] = false;
            payment["shopeepay_spaylater_enabled"] = false;
            payment["credit_base_rate"] = "";
            payment["credit_markup_rate"] = "";
            payment["spaylater_base_rate"] = "";
            payment["spaylater_markup_rate"] = "";
            payment["merchant_ext_id"] = "";
            payment["store_ext_id"] = "";
          }

          payment["dynamic_info"] = {};

          if (route.dynamic_info) {
            // if (route.dynamic_info.currency) {
            //   let idList = [];
            //   route.dynamic_info.currency.forEach((h) => {
            //     idList.push(h.id);
            //   });
            //   setSelectAllowedCurrencyList(idList);

            //   payment["currency_list"] = idList;
            // }

            // payment["currency_list"] = selectAllowedCurrencyList;
            if (route?.currencies) {
              payment["currency_list"] = route.currencies;
            }

            payment["enabled_3ds"] = route.dynamic_info?.enabled_3ds
              ? route.dynamic_info?.enabled_3ds
              : false;


            route.dynamic_info?.grabpay_merchant_id &&
              (payment["grabpay_merchant_id"] =
                route.dynamic_info.grabpay_merchant_id);

            route.dynamic_info?.grabpay_terminal_id &&
              (payment["grabpay_terminal_id"] =
                route.dynamic_info.grabpay_terminal_id);

            route.dynamic_info?.payment_expiry_time &&
              (payment["payment_expiry_time"] =
                route.dynamic_info.payment_expiry_time);

            route.dynamic_info?.min_amt_postpaid &&
              (payment["min_amt_postpaid"] =
                route.dynamic_info.min_amt_postpaid);

            route.dynamic_info?.min_amt_installment_4 &&
              (payment["min_amt_installment_4"] =
                route.dynamic_info.min_amt_installment_4);

            route.dynamic_info?.touchngo_expiry_time &&
              (payment["touchngo_expiry_time"] =
                route.dynamic_info.touchngo_expiry_time);

            route.dynamic_info?.touchngo_merchant_id &&
              (payment["touchngo_merchant_id"] =
                route.dynamic_info.touchngo_merchant_id);

            route.dynamic_info?.touchngo_client_id &&
              (payment["touchngo_client_id"] =
                route.dynamic_info.touchngo_client_id);

            route.dynamic_info?.touchngo_client_secret &&
              (payment["touchngo_client_secret"] =
                route.dynamic_info.touchngo_client_secret);

            route.dynamic_info?.is_autodebit_enabled &&
              (payment["is_autodebit_enabled"] =
                route.dynamic_info.is_autodebit_enabled);

            route.dynamic_info?.autodebit_amount &&
              (payment["autodebit_amount"] =
                route.dynamic_info.autodebit_amount);

            payment["installment_4"] = route.dynamic_info?.installment_4
              ? route.dynamic_info?.installment_4
              : false;

            payment["postpaid"] = route.dynamic_info?.postpaid
              ? route.dynamic_info?.postpaid
              : false;

            route.dynamic_info?.pf_id &&
              (payment["pf_id"] = route.dynamic_info.pf_id);

            route.dynamic_info?.sub_name &&
              (payment["sub_name"] = route.dynamic_info.sub_name);

            route.dynamic_info?.sub_id &&
              (payment["sub_id"] = route.dynamic_info.sub_id);

            route.dynamic_info?.sub_street &&
              (payment["sub_street"] = route.dynamic_info.sub_street);

            route.dynamic_info?.sub_city &&
              (payment["sub_city"] = route.dynamic_info.sub_city);

            route.dynamic_info?.sub_country_code &&
              (payment["sub_country_code"] =
                route.dynamic_info.sub_country_code);

            route.dynamic_info?.sub_postal_code &&
              (payment["sub_postal_code"] = route.dynamic_info.sub_postal_code);

            payment["mcc"] = route.dynamic_info?.mcc
              ? route.dynamic_info?.mcc
              : "";

            route.dynamic_info?.min_card_range &&
              (payment["min_card_range"] = route.dynamic_info.min_card_range);

            route.dynamic_info?.max_card_range &&
              (payment["max_card_range"] = route.dynamic_info.max_card_range);

            route.dynamic_info?.paynow_descriptor_id &&
              (payment["paynow_descriptor_id"] = route.dynamic_info.paynow_descriptor_id);

            route.dynamic_info?.ref_2 &&
              (payment["ref_2"] = route.dynamic_info.ref_2);

            route.dynamic_info?.payee &&
              (payment["payee"] = route.dynamic_info.payee);

            route.dynamic_info?.line_pay_merchant_id &&
              (payment["line_pay_merchant_id"] = route.dynamic_info.line_pay_merchant_id);

            route.dynamic_info?.sub_mid &&
              (payment["sub_mid"] = route.dynamic_info.sub_mid);

            if (showAtomeDynamicField(route.payment_host?.name)) {
              if (route.dynamic_info?.username != null) {
                payment["atome_username"] = route.dynamic_info.username;
              }
              if (route.dynamic_info?.password != null) {
                payment["atome_password"] = route.dynamic_info.password;
              }
            }
            if (showWeChatDynamicField(route.payment_host?.name)) {
              if (route.dynamic_info?.partner_id != null) {
                payment["partner_id"] = route.dynamic_info.partner_id;
              }
            }
            route.dynamic_info?.revpay_merchant_id &&
              (payment["revpay_merchant_id"] =
                route.dynamic_info.revpay_merchant_id);

            payment["enable_vis"] = route.dynamic_info?.enable_vis
              ? route.dynamic_info?.enable_vis
              : false;

            payment["default_bin_routing"] = route.dynamic_info
              ?.default_bin_routing
              ? route.dynamic_info.default_bin_routing
              : true;

            if (route.dynamic_info?.vis_dynamic_info) {
              payment["enable_vis"] = true;

              route.dynamic_info?.vis_dynamic_info?.vis_dynamic_info_id &&
                (payment["vis_dynamic_info_id"] =
                  route.dynamic_info?.vis_dynamic_info?.vis_dynamic_info_id);

              route.dynamic_info.vis_dynamic_info
                .partner_merchant_reference_id &&
                (payment["partner_merchant_reference_id"] =
                  route.dynamic_info.vis_dynamic_info.partner_merchant_reference_id);
            }

            if (route.dynamic_info?.default_bin_routing === false) {
              if (route.dynamic_info?.supercede_info) {
                route.dynamic_info?.supercede_info?.min_card_range &&
                  (payment["min_card_range"] =
                    route.dynamic_info?.supercede_info?.min_card_range);

                route.dynamic_info?.supercede_info?.max_card_range &&
                  (payment["max_card_range"] =
                    route.dynamic_info?.supercede_info?.max_card_range);
              }
            }
          } else {
            payment["grabpay_merchant_id"] = "";
            payment["grabpay_terminal_id"] = "";
            payment["payment_expiry_time"] = "";
            payment["postpaid"] = false;
            payment["installment_4"] = false;
            payment["min_amt_postpaid"] = "";
            payment["min_amt_installment_4"] = "";
            payment["pf_id"] = "";
            payment["sub_name"] = "";
            payment["sub_id"] = "";
            payment["sub_street"] = "";
            payment["sub_city"] = "";
            payment["sub_country_code"] = "";
            payment["sub_postal_code"] = "";
            payment["mcc"] = "";
            payment["enable_vis"] = false;
            payment["default_bin_routing"] = true;
            payment["vis_dynamic_info_id"] = "";
            payment["partner_merchant_reference_id"] = "";
            payment["enabled_3ds"] = false;
            payment["currency_list"] = [];
            payment["touchngo_expiry_time"] = "";
            payment["touchngo_merchant_id"] = "";
            payment["touchngo_client_id"] = "";
            payment["touchngo_client_secret"] = ""
          }

          if (route.payment_host?.name.toLocaleLowerCase().includes(PAYMENT_HOST_LIST.NOMU)) {

            if (route.dynamic_info?.processing_account_id)
              payment["processing_account_id"] = route.dynamic_info?.processing_account_id;

            if (route.default_bin_routing === false && route.dynamic_info?.preset_info) {
              payment["default_bin_routing"] = route.default_bin_routing;

              route.dynamic_info?.preset_info?.min_card_range &&
                (payment["min_card_range"] =
                  route.dynamic_info?.preset_info?.min_card_range);

              route.dynamic_info?.preset_info?.max_card_range &&
                (payment["max_card_range"] =
                  route.dynamic_info?.preset_info?.max_card_range);
            }
          }

          if (route.payment_host?.name.toLocaleLowerCase().includes(PAYMENT_HOST_LIST.RAZER)) {

            if (route.dynamic_info?.secret_key)
              payment["secret_key"] = route.dynamic_info.secret_key;

            if (route.dynamic_info?.verification_key)
              payment["verification_key"] = route.dynamic_info.verification_key;

            if (route.dynamic_info?.merchant_id)
              payment["merchant_id"] = route.dynamic_info.merchant_id;

            if (route.dynamic_info?.channel)
              payment["channel"] = route.dynamic_info.channel;
          }

          if (showFiuuDynamicField(route.payment_host?.name)) {

            if (route.dynamic_info?.secret_key)
              payment["secret_key"] = route.dynamic_info.secret_key;

            if (route.dynamic_info?.merchant_id)
              payment["merchant_id"] = route.dynamic_info.merchant_id;

            if (route.dynamic_info?.terminal_id)
              payment["terminal_id"] = route.dynamic_info.terminal_id;
          }

          if (showAllinpayDynamicField(route.payment_host?.name)) {
            if (route.dynamic_info?.merchant_id)
              payment["merchant_id"] = route.dynamic_info.merchant_id;

            if (route.dynamic_info?.terminal_id)
              payment["terminal_id"] = route.dynamic_info.terminal_id;

            payment["allinpay_partner_id"] = route.dynamic_info?.partner_id ?? "";
            payment["allinpay_base_rate_local"] = route.dynamic_info?.base_rate_local != null
              ? toNumberInputString(route.dynamic_info.base_rate_local) : "";
            payment["allinpay_markup_rate_local"] = route.dynamic_info?.markup_rate_local != null
              ? toNumberInputString(route.dynamic_info.markup_rate_local) : "";
            payment["allinpay_base_rate_foreign"] = route.dynamic_info?.base_rate_foreign != null
              ? toNumberInputString(route.dynamic_info.base_rate_foreign) : "";
            payment["allinpay_markup_rate_foreign"] = route.dynamic_info?.markup_rate_foreign != null
              ? toNumberInputString(route.dynamic_info.markup_rate_foreign) : "";
          }

          if (route.payment_host?.name.toLocaleLowerCase().includes(PAYMENT_HOST_LIST.NETS)) {

            if (route.dynamic_info?.secret_id)
              payment["secret_id"] = route.dynamic_info.secret_id;

            if (route.dynamic_info?.mid)
              payment["mid"] = route.dynamic_info.mid;

            if (route.dynamic_info?.tid)
              payment["tid"] = route.dynamic_info.tid;

            if (route.dynamic_info?.institution_code)
              payment["institution_code"] = route.dynamic_info.institution_code;

            if (route.dynamic_info?.key_id)
              payment["key_id"] = route.dynamic_info.key_id;
          }


          if (route.payment_host?.name.toLocaleLowerCase().includes(PAYMENT_HOST_LIST.SHOPBACK)) {

            if (route.dynamic_info?.access_key_id)
              payment["access_key_id"] = route.dynamic_info.access_key_id;

            if (route.dynamic_info?.access_key_secret)
              payment["access_key_secret"] = route.dynamic_info.access_key_secret;

            if (route.dynamic_info?.pos_id)
              payment["pos_id"] = route.dynamic_info.pos_id;
          }

          if (showHostFiuuDynamicField(route.payment_host?.name)) {

            if (route.dynamic_info?.host_fiuu_mid)
              payment["host_fiuu_mid"] = route.dynamic_info.host_fiuu_mid;

            if (route.dynamic_info?.host_fiuu_verify_key)
              payment["host_fiuu_verify_key"] = route.dynamic_info.host_fiuu_verify_key;

            if (route.dynamic_info?.host_fiuu_secret_key)
              payment["host_fiuu_secret_key"] = route.dynamic_info.host_fiuu_secret_key;

            // if(route.dynamic_info?.host_fiuu_email)
            //   payment["host_fiuu_email"] = route.dynamic_info.host_fiuu_email;

            // if(route.dynamic_info?.host_fiuu_password)
            //   payment["host_fiuu_password"] = route.dynamic_info.host_fiuu_password;
          }

          if (showFiuuFixedFeeDynamicField(route.payment_host?.name)) {
            payment["base_fix_fee_local"] = route.dynamic_info?.base_fix_fee_local !== null && route.dynamic_info?.base_fix_fee_local !== undefined
              ? toNumberInputString(route.dynamic_info.base_fix_fee_local) : "0";
            payment["markup_fix_fee_local"] = route.dynamic_info?.markup_fix_fee_local !== null && route.dynamic_info?.markup_fix_fee_local !== undefined
              ? toNumberInputString(route.dynamic_info.markup_fix_fee_local) : "0";
            payment["base_fix_fee_foreign"] = route.dynamic_info?.base_fix_fee_foreign !== null && route.dynamic_info?.base_fix_fee_foreign !== undefined
              ? toNumberInputString(route.dynamic_info.base_fix_fee_foreign) : "0";
            payment["markup_fix_fee_foreign"] = route.dynamic_info?.markup_fix_fee_foreign !== null && route.dynamic_info?.markup_fix_fee_foreign !== undefined
              ? toNumberInputString(route.dynamic_info.markup_fix_fee_foreign) : "0";
          }

          if (showCybersourceDynamicField(route.payment_host?.name)) {

            if (route.dynamic_info?.cybs_merchant_id)
              payment["cybs_merchant_id"] = route.dynamic_info.cybs_merchant_id;

            if (route.dynamic_info?.cybs_merchant_keyid)
              payment["cybs_merchant_keyid"] = route.dynamic_info.cybs_merchant_keyid;

            if (route.dynamic_info?.cybs_merchant_secretkey)
              payment["cybs_merchant_secretkey"] = route.dynamic_info.cybs_merchant_secretkey;

            if (route.dynamic_info?.mpi_type !== undefined)
              payment["cybs_mpi_type"] = route.dynamic_info.mpi_type;

            if (route.dynamic_info?.ipp_enabled !== undefined)
              payment["ipp_enabled"] = route.dynamic_info.ipp_enabled;

            if (route.dynamic_info?.ipp_plans) {
              // Convert old format to new format if needed
              const plans = route.dynamic_info.ipp_plans.map(plan => {
                // If plan has old format fields (mid, username, password), convert to new format
                if (plan.mid || plan.username || plan.password) {
                  return {
                    bank: plan.bank || '',
                    months: plan.months || '',
                    ipp_merchant_id: plan.mid || plan.ipp_merchant_id || '',
                    ipp_merchant_keyid: plan.username || plan.ipp_merchant_keyid || '',
                    ipp_merchant_secretkey: plan.password || plan.ipp_merchant_secretkey || ''
                  };
                }
                // Otherwise, use as-is (already in new format)
                return plan;
              });
              payment["ipp_plans"] = plans;
            }
          }

          if (route.payment_host?.name.toLowerCase().startsWith(PAYMENT_HOST_LIST.DCI)) {

            if (route.dynamic_info?.acquiring_institution_id)
              payment["acquiring_institution_id"] = route.dynamic_info.acquiring_institution_id;

            if (route.dynamic_info?.forwarding_institution_id)
              payment["forwarding_institution_id"] = route.dynamic_info.forwarding_institution_id;

            if (route.dynamic_info?.acceptor_id)
              payment["acceptor_id"] = route.dynamic_info.acceptor_id;

            if (route.dynamic_info?.processing_code)
              payment["processing_code"] = route.dynamic_info.processing_code;

            if (route.dynamic_info?.dci_descriptor)
              payment["dci_descriptor"] = route.dynamic_info.dci_descriptor;
          }

          if (route.payment_host?.name.toLocaleLowerCase().includes(PAYMENT_HOST_LIST.REVPAY)) {
            if (route.dynamic_info?.revpay_merchant_id)
              payment["revpay_merchant_id"] = route.dynamic_info.revpay_merchant_id;

          }

          if (showShopeePayMYDynamicField(route.payment_host?.name)) {
            if(route.dynamic_info?.convenience_fee_indicator)
              payment["convenience_fee_indicator"] = route.dynamic_info.convenience_fee_indicator;

            if(route.dynamic_info?.convenience_fee_fixed)
              payment["convenience_fee_fixed"] = route.dynamic_info.convenience_fee_fixed;

            if(route.dynamic_info?.convenience_fee_percentage)
              payment["convenience_fee_percentage"] = route.dynamic_info.convenience_fee_percentage;

            if(route.dynamic_info?.my_merchant_ext_id)
              payment["my_merchant_ext_id"] = route.dynamic_info.my_merchant_ext_id;

            if(route.dynamic_info?.my_store_ext_id)
              payment["my_store_ext_id"] = route.dynamic_info.my_store_ext_id;

            if(route.dynamic_info?.is_autodebit_enabled)
              payment["is_autodebit_enabled"] = route.dynamic_info.is_autodebit_enabled;

            if(route.dynamic_info?.autodebit_amount)
              payment["autodebit_amount"] = route.dynamic_info.autodebit_amount;
          }

          if (showDashDynamicField(route.payment_host?.name)) {
            if(route.dynamic_info?.counter_id)
              payment["counter_id"] = route.dynamic_info.counter_id;

            if(route.dynamic_info?.counter_msisdn)
              payment["counter_msisdn"] = route.dynamic_info.counter_msisdn;

            if(route.dynamic_info?.counter_pin)
              payment["counter_pin"] = route.dynamic_info.counter_pin;
          }
          if (showAliPayDynamicField(route.payment_host?.name)) {
            if (route.dynamic_info?.store_id) {
              payment["store_id"] = route.dynamic_info.store_id;
            }
          }
          if (showWeChatDynamicField(route.payment_host?.name)) {
            if (route.dynamic_info?.partner_id) {
              payment["partner_id"] = route.dynamic_info.partner_id;
            }
          }

          if (showDynamicField(route.payment_host?.name, PAYMENT_HOST_LIST.SCB) && showDynamicField(route.payment_method?.name, "qr")) {
            if (route.dynamic_info?.merchant_name && route.dynamic_info?.status) {
              payment["merchant_name"] = route.dynamic_info?.merchant_name;
              payment["status"] = route.dynamic_info?.status;
            }
          }

          if (route.payment_host.is_route_gw2) {
            const { route_enabled, gw2_params } = route.gw2_proxy_route || {};
            const safeGw2Params = gw2_params ?? { mcptid: "", etype: "" };
            payment["route_enabled"] = route_enabled || false;
            payment["gw2_params"] = {
              mcptid: safeGw2Params.mcptid,
              etype: safeGw2Params.etype
            };

            routeGw2Obj[index] = {
              name: route.payment_host?.name.toLocaleLowerCase(),
              isRouteGw2: true
            }
          } else {
            payment["route_enabled"] = false;
            payment["gw2_params"] = {
              mcptid: "",
              etype: ""
            };
          }

          payment["mpi_type"] = route.mpi_type || 0;
          payment["mpi_id"] = route.mpi_id?.id || "";

          if (route.payment_method?.name.toLowerCase() === "card") {
            paymentMethodObj[index] = "card"
          }

          delete initialRow["payment_charges_payment_mapping"];

          initialRow.push(payment);
        }

      });
      setRoute(initialRow);
      setSelectedPaymentBrands(bList);
      setSelectedPaymentHosts(pList);
      if (!isEmpty(routeGw2Obj)) setRouteGw2(routeGw2Obj);
      if (!isEmpty(paymentMethodObj)) setPaymentMethod(paymentMethodObj);
    }
  }, [terminalDetailsLoaded]);

  if (terminalDetailsLoaded && terminalDetails) {
    return (
      <Container>
        <Box>
          <Formik
            enableReinitialize
            initialValues={{
              mode: terminalDetails.mode?.mode,
              terminal_id: terminalDetails.terminal_id,
              businessEntity: terminalDetails.merchant.business_entity.id,
              merchant: terminalDetails.merchant.id,
              operator_id: terminalDetails.operator_credentials?.username,
              operator_password: terminalDetails.operator_credentials?.hashed_password,
              payment: route,
            }}
            onSubmit={handleSubmit}
            validationSchema={Yup.object().shape({
              operator_password: Yup.string().when("$mode", {
                is: (val) => val?.toLowerCase() === "ffastpay",
                then: (schema) =>
                  schema
                    .min(6, 'Password should be of minimum 6 characters length')
                    // .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
                    // .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
                    // .matches(/\d/, 'Password must contain at least one number')
                    .required("Operator Password is required"),
                otherwise: (schema) => schema.notRequired(),
              }),
              payment: Yup.array().of(
                Yup.object().shape({

                  payment_method: Yup.string().required(
                    "Payment method must be selected"
                  ),
                  payment_brand: Yup.string().required(
                    "Payment brand must be selected"
                  ),
                  payment_host: Yup.string().required(
                    "Payment host must be selected"
                  ),
                  base_rate: Yup.number()
                    .nullable()
                    .transform(transformEmptyToNull),
                  markup_rate: Yup.number()
                    .nullable()
                    .transform(transformEmptyToNull),
                  credit_base_rate: Yup.number()
                    .transform(transformEmptyToNull)
                    .when("shopeepay_credit_enabled", {
                      is: (creditEnabled) => creditEnabled,
                      then: (schema) => schema.required("This field is required"),
                      otherwise: (schema) => schema.notRequired().nullable(),
                    }
                    ),
                  credit_markup_rate: Yup.number()
                    .transform(transformEmptyToNull)
                    .when("shopeepay_credit_enabled", {
                      is: (creditEnabled) => creditEnabled,
                      then: (schema) => schema.required("This field is required"),
                      otherwise: (schema) => schema.notRequired().nullable(),
                    }
                    ),
                  spaylater_base_rate: Yup.number()
                    .transform(transformEmptyToNull)
                    .when("shopeepay_spaylater_enabled", {
                      is: (spaylaterEnabled) => spaylaterEnabled,
                      then: (schema) => schema.required("This field is required"),
                      otherwise: (schema) => schema.notRequired().nullable(),
                    }
                    ),
                  spaylater_markup_rate: Yup.number()
                    .transform(transformEmptyToNull)
                    .when("shopeepay_spaylater_enabled", {
                      is: (spaylaterEnabled) => spaylaterEnabled,
                      then: (schema) =>
                        schema.required("This field is required"),
                      otherwise: (schema) => schema.notRequired().nullable(),
                    }
                    ),
                  shopeepay_credit_enabled: Yup.boolean(),
                  shopeepay_spaylater_enabled: Yup.boolean(),
                  shopeepay_wallet_enabled: Yup.boolean(),
                  is_shopeepay_brand: Yup.boolean(),
                  merchant_ext_id: Yup.string(),
                  store_ext_id: Yup.string(),
                  base_rate_installment: Yup.number()
                    .transform(transformEmptyToNull)
                    .nullable(),
                  markup_rate_installment: Yup.number()
                    .nullable()
                    .transform(transformEmptyToNull)
                    .nullable(),
                  currency_list: Yup.array()
                    .of(
                      Yup.object().shape({
                        id: Yup.string().required(),
                        min_amount: Yup.number()
                          .transform((value) => (isNaN(value) ? undefined : value))
                          .required('Min amount is required')
                          .min(0, "Min amount must be at least 0"),
                      })
                    )
                    .min(1, 'At least one currency must be selected').required(),
                  payee: Yup.string().when('payment_host', {
                    is: 'liquidnet',
                    then: Yup.string()
                      .required('Payee is required for liquidnet')
                      .length(15, 'Payee must be exactly 15 characters (4000571 + 8 characters)')
                      .matches(/^4000571.{8}$/, 'Payee must start with 4000571 and have exactly 8 additional characters'),
                    otherwise: Yup.string()
                  }),
                  line_pay_merchant_id: Yup.string().when('payment_host', {
                    is: 'linepay',
                    then: Yup.string()
                      .required('LINE Pay Merchant ID is required for PromptPay')
                      .max(100, 'LINE Pay Merchant ID must be at most 100 characters'),
                    otherwise: Yup.string()
                  }),
                  sub_mid: Yup.string().when('payment_host', {
                    is: 'fomopay',
                    then: Yup.string()
                      .max(128, 'Sub MID must be at most 128 characters'),
                    otherwise: Yup.string()
                  }),
                  atome_username: Yup.string().when('payment_host', {
                    is: 'atome',
                    then: (schema) =>
                      schema
                        .required('Username is required for Atome')
                        .max(50, 'Username must be at most 50 characters'),
                    otherwise: (schema) => schema.notRequired(),
                  }),
                  atome_password: Yup.string().when('payment_host', {
                    is: 'atome',
                    then: (schema) =>
                      schema
                        .required('Password is required for Atome')
                        .max(255, 'Password must be at most 255 characters'),
                    otherwise: (schema) => schema.notRequired(),
                  }),
                })
              ),
            })}
          >
            {(props) => {
              console.log("props", props);
              const {
                values,
                touched,
                errors,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
              } = props;
              console.log({ values })
              return (
                <FormDialog
                  open={open}
                  onClose={onClose}
                  title="Terminal Edit"
                  scroll="paper"
                  handleSubmit={handleSubmit}
                  loading={isSubmitting}
                  sx={{ p: 0 }}
                >
                  <Form autoComplete="off" noValidate>
                    <FormErrorScroll />
                    <Grid
                      container
                      rowSpacing={2}
                      columnSpacing={3}
                      sx={{ alignItems: "center", py: 2 }}
                    >
                      <Grid
                        container
                        rowSpacing={2}
                        sx={{
                          position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1, alignItems: "center", px: 10, ml: 3, py: 2
                        }}
                      >
                        <Grid item md={2} xs={2}>
                          <Typography variant="subtitle1" align="right">
                            Terminal ID:
                          </Typography>
                        </Grid>

                        <Grid item md={2} xs={2}>
                          <Typography sx={{ ml: 2 }}>
                            {terminalDetails.terminal_id}
                          </Typography>
                        </Grid>

                        <Grid item md={2} xs={2}>
                          <Typography variant="subtitle1" align="right">
                            Mode:
                          </Typography>
                        </Grid>

                        <Grid item md={2} xs={2}>
                          <Typography sx={{ ml: 2 }}>
                            {terminalDetails.mode &&
                              terminalDetails.mode.mode}
                          </Typography>
                        </Grid>

                        <Grid item md={2} xs={2}>
                          <Typography variant="subtitle1" align="right">
                            Merchant:
                          </Typography>
                        </Grid>

                        <Grid item md={2} xs={2}>
                          <Typography sx={{ ml: 2 }}>
                            {terminalDetails.merchant &&
                              terminalDetails.merchant.name}
                          </Typography>
                        </Grid>

                        {terminalDetails.mode?.mode?.toLowerCase() === "ffastpay" &&
                          <>
                            <Grid item md={2} xs={2}>
                              <Typography variant="subtitle1" align="right">
                                Operator ID:
                              </Typography>
                            </Grid>

                            <Grid item md={2} xs={2}>
                              <TextField
                                sx={{ ml: 2 }}
                                size="small"
                                label="Operator ID"
                                id={"operator_id"}
                                name={"operator_id"}
                                value={values.operator_id}
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                                disabled={isSubmitting}
                              />
                            </Grid>

                            <Grid item md={2} xs={2}>
                              <Typography variant="subtitle1" align="right">
                                Operator Password:
                              </Typography>
                            </Grid>

                            <Grid item md={2.5} xs={2.5}>
                              <TextField
                                sx={{ ml: 2 }}
                                type={showPassword ? 'text' : 'password'}
                                size="small"
                                fullWidth
                                label="Operator Password"
                                name="operator_password"
                                value={values.operator_password}
                                onChange={(e) => {
                                  handleChange(e);
                                  setAllowShowPassword(true);
                                }}
                                disabled={isSubmitting || isLoadingGenerateOperatorPassowrd}
                                error={Boolean(touched.operator_password && errors.operator_password)}
                                helperText={touched.operator_password && errors.operator_password}
                                {...(allowShowPassword && {
                                  InputProps: {
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton onClick={() => setShowPassword(!showPassword)}>
                                          {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                      </InputAdornment>
                                    )
                                  }
                                })}
                              />
                            </Grid>

                            <Grid item md={2} xs={2} sx={{ ml: 3 }}>
                              <LoadingButton
                                variant="outlined"
                                color="error"
                                loading={isLoadingGenerateOperatorPassowrd}
                                onClick={() => handleGenerateOperatorPassword(data => setFieldValue("operator_password", data.operator_password))}
                              >
                                Regenerate
                              </LoadingButton>
                            </Grid>
                          </>
                        }
                      </Grid>

                      <Grid item md={12} xs={12} sx={{ mx: 3, mb: 2 }}>
                        <Divider />
                      </Grid>

                      <Grid item md={12} xs={12} sx={{ maxHeight: '60vh', overflowY: 'auto' }}>
                        <FieldArray name="payment">
                          {({ insert, remove, push }) => (
                            <Box>
                              {values.payment?.length > 0 &&
                                values.payment.map((row, index) => (
                                  <Card sx={{ p: 2, m: 2, mt: 0, mx: 3 }} key={index}>
                                    <Stack
                                      direction="row"
                                      justifyContent="space-between"
                                      sx={{ mb: 3 }}
                                    >
                                      <Typography variant="subtitle1">
                                        Route Mapping
                                      </Typography>
                                      {
                                        !["add"].includes(values.payment[index].action?.toLowerCase()) && (
                                          <Box spacing={2}>
                                            <Box>
                                              {values.payment[index].action !==
                                                "update" &&
                                                values.payment[index].action !==
                                                "unsuspend" && (
                                                  <TextField
                                                    id={`payment.${index}.action_message`}
                                                    label="Reason"
                                                    variant="filled"
                                                    onChange={handleChange}
                                                    value={
                                                      values.payment[index]
                                                        .action_message
                                                        ? values.payment[index]
                                                          .action_message
                                                        : ""
                                                    }
                                                    required
                                                    size="small"
                                                    sx={{ mr: 2 }}
                                                  />
                                                )}
                                              <TextField
                                                id={`payment.${index}.action`}
                                                name={`payment.${index}.action`}
                                                select
                                                label="Action"
                                                value={values.payment[index].action}
                                                onChange={(e) => handleChange(e)}
                                                sx={{ minWidth: 120 }}
                                                size="small"
                                                variant="filled"
                                              >
                                                {/* <MenuItem value="add">
                                                    Add
                                                  </MenuItem> */}
                                                <MenuItem value="update">
                                                  Update
                                                </MenuItem>
                                                <MenuItem
                                                  value={
                                                    values.payment[index].suspended
                                                      ? "unsuspend"
                                                      : "suspend"
                                                  }
                                                >
                                                  {values.payment[index].suspended
                                                    ? "Unsuspend"
                                                    : "Suspend"}
                                                </MenuItem>
                                                <MenuItem value="remove">
                                                  Delete
                                                </MenuItem>
                                              </TextField>
                                            </Box>
                                          </Box>
                                        )
                                      }

                                      {["add"].includes(values.payment[index].action?.toLowerCase()) && (
                                        <Button
                                          variant="outlined"
                                          color="error"
                                          sx={{ mx: 2 }}
                                          onClick={() => {
                                            remove(index);
                                            if (paymentMethod[index]) {
                                              const newObj = { ...paymentMethod };
                                              delete newObj[index];
                                              setPaymentMethod(newObj);
                                            }
                                          }}
                                          startIcon={<Close />}
                                        >
                                          Delete
                                        </Button>
                                      )}
                                    </Stack>
                                    <Stack
                                      direction="row"
                                      justifyContent="space-between"
                                      sx={{ mb: 3 }}
                                      spacing={2}
                                    >
                                      <TextField
                                        id={`payment.${index}.payment_method`}
                                        name={`payment.${index}.payment_method`}
                                        select
                                        label="Payment Method"
                                        value={
                                          values.payment[index].payment_method
                                        }
                                        onChange={(e, child) => {
                                          handleChange(e);
                                          //! Payment Brand
                                          let tempB = [
                                            ...selectedPaymentBrands,
                                          ];
                                          tempB[index] = "";
                                          setSelectedPaymentBrands(tempB);

                                          //! Payment Host
                                          let temp = [...selectedPaymentHosts];
                                          temp[index] = "";
                                          setSelectedPaymentHosts(temp);
                                          setPaymentMethod({ ...paymentMethod, [index]: child.props["dataPaymentMethod"] });

                                          setFieldValue(
                                            `payment.${index}.payment_host`,
                                            ""
                                          );
                                          setFieldValue(
                                            `payment.${index}.payment_brand`,
                                            ""
                                          );
                                        }}
                                        sx={{ width: "100%" }}
                                        disabled={
                                          values.payment[index].action ===
                                          "Remove"
                                        }
                                      >
                                        {terminalOptionsLoaded
                                          ? terminalOptions.map((method) => (
                                            <MenuItem
                                              key={method.id}
                                              value={method.id}
                                              dataPaymentMethod={method.name}
                                            >
                                              {method.name}
                                            </MenuItem>
                                          ))
                                          : []}
                                      </TextField>
                                      <TextField
                                        id={`payment.${index}.payment_brand`}
                                        name={`payment.${index}.payment_brand`}
                                        select
                                        label="Payment Brand"
                                        value={
                                          values.payment[index].payment_brand
                                        }
                                        onChange={(e) => {
                                          handleChange(e);

                                          //! For payment brand
                                          const brand = paymentBrands.find(
                                            (h) => {
                                              return h.id === e.target.value;
                                            }
                                          );
                                          const brandName = brand?.name?.toLocaleLowerCase() || "";
                                          if (brand) {
                                            let tempB = [
                                              ...selectedPaymentBrands,
                                            ];
                                            tempB[index] = brandName;
                                            setSelectedPaymentBrands(tempB);
                                          }

                                          const isShopeeBrand = brandName === PAYMENT_HOST_LIST.SHOPEEPAY;
                                          setFieldValue(`payment.${index}.is_shopeepay_brand`, isShopeeBrand);
                                          if (isShopeeBrand) {
                                            setFieldValue(`payment.${index}.shopeepay_wallet_enabled`, true);
                                            setFieldValue(`payment.${index}.shopeepay_credit_enabled`, false);
                                            setFieldValue(`payment.${index}.shopeepay_spaylater_enabled`, false);
                                            setFieldValue(`payment.${index}.credit_base_rate`, "");
                                            setFieldValue(`payment.${index}.credit_markup_rate`, "");
                                            setFieldValue(`payment.${index}.spaylater_base_rate`, "");
                                            setFieldValue(`payment.${index}.spaylater_markup_rate`, "");
                                          } else {
                                            setFieldValue(`payment.${index}.is_shopeepay_brand`, false);
                                            setFieldValue(`payment.${index}.shopeepay_wallet_enabled`, false);
                                            setFieldValue(`payment.${index}.shopeepay_credit_enabled`, false);
                                            setFieldValue(`payment.${index}.shopeepay_spaylater_enabled`, false);
                                            setFieldValue(`payment.${index}.credit_base_rate`, "");
                                            setFieldValue(`payment.${index}.credit_markup_rate`, "");
                                            setFieldValue(`payment.${index}.spaylater_base_rate`, "");
                                            setFieldValue(`payment.${index}.spaylater_markup_rate`, "");
                                          }

                                          //! For payment host
                                          let temp = [...selectedPaymentHosts];
                                          temp[index] = "";
                                          setSelectedPaymentHosts(temp);

                                          setFieldValue(
                                            `payment.${index}.payment_host`,
                                            ""
                                          );
                                        }}
                                        sx={{ width: "100%" }}
                                        disabled={
                                          values.payment[index].action ===
                                          "Remove"
                                        }
                                      >
                                        {findPossibleBrands(
                                          values.payment[index].payment_method
                                        )}
                                      </TextField>
                                      <TextField
                                        id={`payment.${index}.payment_host`}
                                        name={`payment.${index}.payment_host`}
                                        select
                                        label="Payment Host"
                                        value={
                                          values.payment[index].payment_host
                                        }
                                        onChange={(e) => {
                                          handleChange(e);
                                          // setFieldValue(
                                          //   `payment.${index}.action`,
                                          //   "add"
                                          // );
                                          const host = paymentHosts.find(
                                            (h) => {
                                              return h.id === e.target.value;
                                            }
                                          );

                                          if (host) {
                                            if (selectedPaymentHosts[index]?.toLowerCase() !== host.name.toLowerCase()) {
                                              resetPaymentHostRateFields(
                                                setFieldValue,
                                                index,
                                                host.name
                                              );
                                            }
                                            let temp = [
                                              ...selectedPaymentHosts,
                                            ];
                                            temp[index] =
                                              host.name.toLocaleLowerCase();

                                            if (host.is_route_gw2) {
                                              let routeGw2Obj = { ...routeGw2 };
                                              routeGw2Obj[index] = {
                                                name: host.name.toLocaleLowerCase(),
                                                isRouteGw2: host.is_route_gw2
                                              };
                                              setRouteGw2(routeGw2Obj);
                                            }

                                            setSelectedPaymentHosts(temp);

                                            setFieldValue(
                                              `payment.${index}`,
                                              resetPaymentRowOnHostChange(values.payment[index], host.id)
                                            );
                                            getCurrencyListByHost(
                                              {
                                                payment_host_ids: [host.id],
                                              },
                                              (res) => {
                                                const [{ ...rest }] = res;
                                                const supportedCurrencies = Array.isArray(rest.currencies) ? rest.currencies : [];
                                                setFieldValue(
                                                  `payment.${index}.currency_list`,
                                                  (values.payment[index]?.currency_list ?? []).filter((c) =>
                                                    supportedCurrencies.some((sc) => sc.id === c.id)
                                                  )
                                                );
                                                if (!currencyByHost)
                                                  return setCurrencyByHost({
                                                    [host.id]: rest,
                                                  });

                                                if (!currencyByHost[host.id]) {
                                                  setCurrencyByHost({ ...currencyByHost, [host.id]: rest });
                                                }
                                              }
                                            );
                                          }
                                        }}
                                        sx={{ width: "100%" }}
                                        disabled={
                                          values.payment[index].action ===
                                          "Remove"
                                        }
                                      >
                                        {findPossibleHosts(
                                          values.payment[index].payment_method,
                                          values.payment[index].payment_brand
                                        )}
                                      </TextField>
                                    </Stack>
                                    <Divider sx={{ mb: 2 }} />
                                    <Grid
                                      container
                                      column={6}
                                      alignItems="flex-start"
                                    >
                                      {values.payment[index].payment_host && currencyByHost &&
                                        <Grid container xs={12}>
                                          <Grid item xs={4}>
                                            <Box sx={{ m: 1 }}>
                                              {(() => {
                                                const { payment_host, currency_list } = values.payment[index];
                                                const currencies = Array.isArray(currencyByHost[payment_host]?.currencies) ? currencyByHost[payment_host]?.currencies : [];
                                                const selectedValues = currencies.filter(({ id }) => currency_list?.some(item => item.id === id));

                                                const hasError = touched?.payment?.[index]?.currency_list && errors?.payment?.[index]?.currency_list;

                                                return (
                                                  <>
                                                    <Typography
                                                      sx={{
                                                        pb: 0.5,
                                                        color: hasError ? "#FF4842" : "#637381",
                                                        fontSize: 12,
                                                      }}
                                                    >
                                                      Currency
                                                    </Typography>
                                                    <Select
                                                      id={`payment.${index}.currency_list`}
                                                      name={`payment.${index}.currency_list`}
                                                      getOptionLabel={option => option.currency}
                                                      getOptionValue={option => option.id}
                                                      closeMenuOnSelect={false}
                                                      isMulti
                                                      options={currencies}
                                                      value={selectedValues}
                                                      onChange={event => setFieldValue(`payment.${index}.currency_list`,
                                                        event.map(({ id, currency }) => {
                                                          const existing = currency_list?.find(c => c.id === id);
                                                          return existing ? existing : { id, min_amount: MIN_AMOUNT_DEFAULT[currency] };
                                                        })
                                                      )}
                                                      styles={{
                                                        control: provided => ({ ...provided, minHeight: "30px", height: "30px" }),
                                                        indicatorsContainer: provided => ({ ...provided, height: "30px" }),
                                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                                      }}
                                                      menuPortalTarget={document.body}
                                                    />
                                                    {hasError && typeof errors.payment[index].currency_list === 'string' && (
                                                      <Typography color="error" fontSize={12}>
                                                        {errors.payment[index].currency_list}
                                                      </Typography>
                                                    )}

                                                    {/* Render Min Amount Input for Each Selected Currency */}
                                                    {currency_list?.length > 0 && (
                                                      <Box sx={{ mt: 2 }}>
                                                        {/* <Typography variant="subtitle2" sx={{ mb: 1 }}>Min Amount</Typography> */}
                                                        {currency_list.map((currencyItem, cIndex) => {
                                                          const currencyInfo = currencies.find(c => c.id === currencyItem.id);
                                                          const currencyName = currencyInfo ? currencyInfo.currency : `Currency ID: ${currencyItem.id}`;
                                                          const fieldName = `payment.${index}.currency_list[${cIndex}].min_amount`;
                                                          const fieldError = errors?.payment?.[index]?.currency_list?.[cIndex]?.min_amount;
                                                          const fieldTouched = touched?.payment?.[index]?.currency_list?.[cIndex]?.min_amount;
                                                          const minAmtError = Boolean(fieldTouched && fieldError);

                                                          return (
                                                            <TextField
                                                              // required
                                                              sx={{ m: 1 }}
                                                              InputLabelProps={{
                                                                shrink: true,
                                                              }}
                                                              InputProps={{
                                                                min: 0,
                                                                step: "any",
                                                                startAdornment: (
                                                                  <InputAdornment position="start">
                                                                    {currencyName}
                                                                  </InputAdornment>
                                                                ),
                                                              }}
                                                              label={`Min Amount`}
                                                              id={fieldName}
                                                              name={fieldName}
                                                              value={currencyItem.min_amount}
                                                              onChange={(event) => {
                                                                const value = event.target.value;

                                                                // Allow empty value so user can clear the input
                                                                if (value === "") {
                                                                  handleChange(event);
                                                                  return;
                                                                }

                                                                // Prevent negative number
                                                                if (Number(value) < 0) {
                                                                  return;
                                                                }

                                                                handleChange(event);
                                                              }}
                                                              onKeyDown={(event) => {
                                                                // Prevent negative, positive sign, and exponential input
                                                                if (["-", "+", "e", "E"].includes(event.key)) {
                                                                  event.preventDefault();
                                                                }
                                                              }}
                                                              type="number"
                                                              error={minAmtError}
                                                              helperText={minAmtError ? fieldError : ""}
                                                              variant="standard"
                                                            />
                                                          );
                                                        })}
                                                      </Box>
                                                    )}
                                                  </>
                                                );
                                              })()}
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      }
                                      {values.payment[index]?.is_shopeepay_brand &&
                                        (selectedPaymentHosts[index]?.toLowerCase() === PAYMENT_HOST_LIST.SHOPEEPAY_SG?.toLowerCase() ||
                                          selectedPaymentHosts[index]?.toLowerCase() === PAYMENT_HOST_LIST.SHOPEEPAY_TH?.toLowerCase()) ? (
                                        <>
                                          <Grid item xs={4}>
                                            <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1, p: 2, m: 1 }}>
                                              <FormControlLabel
                                                control={<Checkbox disabled />}
                                                label={<Typography sx={{ color: 'rgba(0, 0, 0, 0.87)' }}>Wallet</Typography>}
                                                name={`payment.${index}.shopeepay_wallet_enabled`}
                                                checked={true}
                                              />
                                              <Grid container spacing={2} sx={{ mt: 1 }}>
                                                <Grid item xs={6}>
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    InputProps={{
                                                      min: 0,
                                                      step: "any",
                                                      startAdornment: (
                                                        <InputAdornment position="start">
                                                          %
                                                        </InputAdornment>
                                                      ),
                                                    }}
                                                    label="Base Rate (Wallet)"
                                                    id={`payment.${index}.base_rate`}
                                                    name={`payment.${index}.base_rate`}
                                                    value={values.payment[index].base_rate}
                                                    onChange={(event) => {
                                                      const value = event.target.value;

                                                      // Allow empty value so user can clear the input
                                                      if (value === "") {
                                                        handleChange(event);
                                                        return;
                                                      }

                                                      // Prevent negative number
                                                      if (Number(value) < 0) {
                                                        return;
                                                      }

                                                      handleChange(event);
                                                    }}
                                                    onKeyDown={(event) => {
                                                      // Prevent negative, positive sign, and exponential input
                                                      if (["-", "+", "e", "E"].includes(event.key)) {
                                                        event.preventDefault();
                                                      }
                                                    }}
                                                    type="number"
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]?.base_rate &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.base_rate
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]?.base_rate &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.base_rate
                                                    }
                                                    variant="standard"
                                                  />
                                                </Grid>

                                                <Grid item xs={6}>
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    InputProps={{
                                                      startAdornment: (
                                                        <InputAdornment position="start">
                                                          %
                                                        </InputAdornment>
                                                      ),
                                                    }}
                                                    label="Markup Rate (Wallet)"
                                                    id={`payment.${index}.markup_rate`}
                                                    name={`payment.${index}.markup_rate`}
                                                    value={values.payment[index].markup_rate}
                                                    onChange={(event) => handleChange(event)}
                                                    type="number"
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]?.markup_rate &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.markup_rate
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]?.markup_rate &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.markup_rate
                                                    }
                                                    variant="standard"
                                                  />
                                                </Grid>
                                              </Grid>
                                            </Box>
                                          </Grid>

                                          <Grid item xs={4}>
                                            <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1, p: 2, m: 1 }}>
                                              <FormControlLabel
                                                control={<Checkbox />}
                                                label="SPayLater"
                                                name={`payment.${index}.shopeepay_spaylater_enabled`}
                                                checked={Boolean(values.payment[index]?.shopeepay_spaylater_enabled)}
                                                onChange={() => {
                                                  const currentValue = values.payment[index]?.shopeepay_spaylater_enabled;
                                                  setFieldValue(`payment.${index}.shopeepay_spaylater_enabled`, !currentValue);
                                                  if (currentValue) {
                                                    setFieldValue(`payment.${index}.spaylater_base_rate`, "");
                                                    setFieldValue(`payment.${index}.spaylater_markup_rate`, "");
                                                  }
                                                }}
                                              />
                                              {values.payment[index]?.shopeepay_spaylater_enabled && (
                                                <Grid container spacing={2} sx={{ mt: 1 }}>
                                                  <Grid item xs={6}>
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      InputProps={{
                                                        min: 0,
                                                        step: "any",
                                                        startAdornment: (
                                                          <InputAdornment position="start">
                                                            %
                                                          </InputAdornment>
                                                        ),
                                                      }}
                                                      label="Base Rate (SPayLater)"
                                                      id={`payment.${index}.spaylater_base_rate`}
                                                      name={`payment.${index}.spaylater_base_rate`}
                                                      value={values.payment[index].spaylater_base_rate}
                                                      onChange={(event) => {
                                                        const value = event.target.value;

                                                        // Allow empty value so user can clear the input
                                                        if (value === "") {
                                                          handleChange(event);
                                                          return;
                                                        }

                                                        // Prevent negative number
                                                        if (Number(value) < 0) {
                                                          return;
                                                        }

                                                        handleChange(event);
                                                      }}
                                                      onKeyDown={(event) => {
                                                        // Prevent negative, positive sign, and exponential input
                                                        if (["-", "+", "e", "E"].includes(event.key)) {
                                                          event.preventDefault();
                                                        }
                                                      }}
                                                      type="number"
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]?.spaylater_base_rate &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.spaylater_base_rate
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]?.spaylater_base_rate &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.spaylater_base_rate
                                                      }
                                                      variant="standard"
                                                    />
                                                  </Grid>

                                                  <Grid item xs={6}>
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      InputProps={{
                                                        startAdornment: (
                                                          <InputAdornment position="start">
                                                            %
                                                          </InputAdornment>
                                                        ),
                                                      }}
                                                      label="Markup Rate (SPayLater)"
                                                      id={`payment.${index}.spaylater_markup_rate`}
                                                      name={`payment.${index}.spaylater_markup_rate`}
                                                      value={values.payment[index].spaylater_markup_rate}
                                                      onChange={(event) => {handleChange(event)}}
                                                      type="number"
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]?.spaylater_markup_rate &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.spaylater_markup_rate
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]?.spaylater_markup_rate &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.spaylater_markup_rate
                                                      }
                                                      variant="standard"
                                                    />
                                                  </Grid>
                                                </Grid>
                                              )}
                                            </Box>
                                          </Grid>

                                          <Grid item xs={4}>
                                            <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1, p: 2, m: 1 }}>
                                              <FormControlLabel
                                                control={<Checkbox />}
                                                label="Debit/Credit Card"
                                                name={`payment.${index}.shopeepay_credit_enabled`}
                                                checked={Boolean(values.payment[index]?.shopeepay_credit_enabled)}
                                                onChange={() => {
                                                  const currentValue = values.payment[index]?.shopeepay_credit_enabled;
                                                  setFieldValue(`payment.${index}.shopeepay_credit_enabled`, !currentValue);
                                                  if (currentValue) {
                                                    setFieldValue(`payment.${index}.credit_base_rate`, "");
                                                    setFieldValue(`payment.${index}.credit_markup_rate`, "");
                                                  }
                                                }}
                                              />
                                              {values.payment[index]?.shopeepay_credit_enabled && (
                                                <Grid container spacing={2} sx={{ mt: 1 }}>
                                                  <Grid item xs={6}>
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      InputProps={{
                                                        min: 0,
                                                        step: "any",
                                                        startAdornment: (
                                                          <InputAdornment position="start">
                                                            %
                                                          </InputAdornment>
                                                        ),
                                                      }}
                                                      label="Base Rate (Debit/Credit Card)"
                                                      id={`payment.${index}.credit_base_rate`}
                                                      name={`payment.${index}.credit_base_rate`}
                                                      value={values.payment[index].credit_base_rate}
                                                      onChange={(event) => {
                                                        const value = event.target.value;

                                                        // Allow empty value so user can clear the input
                                                        if (value === "") {
                                                          handleChange(event);
                                                          return;
                                                        }

                                                        // Prevent negative number
                                                        if (Number(value) < 0) {
                                                          return;
                                                        }

                                                        handleChange(event);
                                                      }}
                                                      onKeyDown={(event) => {
                                                        // Prevent negative, positive sign, and exponential input
                                                        if (["-", "+", "e", "E"].includes(event.key)) {
                                                          event.preventDefault();
                                                        }
                                                      }}
                                                      type="number"
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]?.credit_base_rate &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.credit_base_rate
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]?.credit_base_rate &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.credit_base_rate
                                                      }
                                                      variant="standard"
                                                    />
                                                  </Grid>

                                                  <Grid item xs={6}>
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      InputProps={{
                                                        startAdornment: (
                                                          <InputAdornment position="start">
                                                            %
                                                          </InputAdornment>
                                                        ),
                                                      }}
                                                      label="Markup Rate (Debit/Credit Card)"
                                                      id={`payment.${index}.credit_markup_rate`}
                                                      name={`payment.${index}.credit_markup_rate`}
                                                      value={values.payment[index].credit_markup_rate}
                                                      onChange={(event) => handleChange(event)}
                                                      type="number"
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]?.credit_markup_rate &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.credit_markup_rate
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]?.credit_markup_rate &&
                                                        errors.payment &&
                                                        errors?.payment[index]?.credit_markup_rate
                                                      }
                                                      variant="standard"
                                                    />
                                                  </Grid>
                                                </Grid>
                                              )}
                                            </Box>
                                          </Grid>
                                          <Grid container xs={12}>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.merchant_ext_id`}
                                                id={`payment.${index}.merchant_ext_id`}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.merchant_ext_id`}
                                                    name={`payment.${index}.merchant_ext_id`}
                                                    label="Merchant Ext ID"
                                                    value={
                                                      values.payment[index].merchant_ext_id
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.merchant_ext_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.merchant_ext_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.merchant_ext_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.merchant_ext_id
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.store_ext_id`}
                                                id={`payment.${index}.store_ext_id`}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.store_ext_id`}
                                                    name={`payment.${index}.store_ext_id`}
                                                    label="Store Ext ID"
                                                    value={
                                                      values.payment[index].store_ext_id
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.store_ext_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.store_ext_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.store_ext_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.store_ext_id
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                          </Grid>
                                        </>
                                      ) : showAllinpayDynamicField(selectedPaymentHosts[index]) ? (
                                        <AllinpayFields
                                          index={index}
                                          values={values}
                                          handleChange={handleChange}
                                          touched={touched}
                                          errors={errors}
                                          selectedPaymentHost={selectedPaymentHosts[index]}
                                          section="rates"
                                        />
                                      ) : (
                                        <>
                                          <Grid item xs={2}>
                                            <TextField
                                              required
                                              sx={{ m: 1 }}
                                              InputLabelProps={{
                                                shrink: true,
                                              }}
                                              InputProps={{
                                                min: 0,
                                                step: "any",
                                                startAdornment: (
                                                  <InputAdornment position="start">
                                                    %
                                                  </InputAdornment>
                                                ),
                                              }}
                                              type="number"
                                              label="Base Rate"
                                              id={`payment.${index}.base_rate`}
                                              name={`payment.${index}.base_rate`}
                                              value={
                                                values.payment[index].base_rate
                                              }
                                              onChange={(event) => {
                                                const value = event.target.value;

                                                // Allow empty value so user can clear the input
                                                if (value === "") {
                                                  handleChange(event);
                                                  return;
                                                }

                                                // Prevent negative number
                                                if (Number(value) < 0) {
                                                  return;
                                                }

                                                handleChange(event);
                                              }}
                                              onKeyDown={(event) => {
                                                // Prevent negative, positive sign, and exponential input
                                                if (["-", "+", "e", "E"].includes(event.key)) {
                                                  event.preventDefault();
                                                }
                                              }}
                                              error={Boolean(
                                                touched.payment &&
                                                touched?.payment[index]
                                                  ?.base_rate &&
                                                errors.payment &&
                                                errors?.payment[index]?.base_rate
                                              )}
                                              helperText={
                                                touched.payment &&
                                                touched?.payment[index]
                                                  ?.base_rate &&
                                                errors.payment &&
                                                errors?.payment[index]?.base_rate
                                              }
                                              variant="standard"
                                            />
                                          </Grid>
                                          <Grid item xs={2}>
                                            <TextField
                                              required
                                              sx={{ m: 1 }}
                                              InputLabelProps={{
                                                shrink: true,
                                              }}
                                              InputProps={{
                                                startAdornment: (
                                                  <InputAdornment position="start">
                                                    %
                                                  </InputAdornment>
                                                ),
                                              }}
                                              type="number"
                                              label="Markup Rate"
                                              id={`payment.${index}.markup_rate`}
                                              name={`payment.${index}.markup_rate`}
                                              value={
                                                values.payment[index].markup_rate
                                              }
                                              onChange={(event) => handleChange(event)}
                                              error={Boolean(
                                                touched.payment &&
                                                touched?.payment[index]
                                                  ?.markup_rate &&
                                                errors.payment &&
                                                errors?.payment[index]
                                                  ?.markup_rate
                                              )}
                                              helperText={
                                                touched.payment &&
                                                touched?.payment[index]
                                                  ?.markup_rate &&
                                                errors.payment &&
                                                errors?.payment[index]?.markup_rate
                                              }
                                              variant="standard"
                                            />
                                          </Grid>
                                        </>
                                      )}

                                      {
                                        (selectedPaymentHosts[index] === PAYMENT_HOST_LIST.FIUU || selectedPaymentHosts[index] === PAYMENT_HOST_LIST.FIUU_DIRECT_PF) && (
                                          <>
                                            <Grid item xs={2}>
                                              <TextField
                                                sx={{ m: 1 }}
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                InputProps={{
                                                  startAdornment: (
                                                    <InputAdornment position="start">
                                                      %
                                                    </InputAdornment>
                                                  ),
                                                }}
                                                type="number"
                                                label="Base Rate (Foreign Card)"
                                                id={`payment.${index}.base_rate_foreign`}
                                                name={`payment.${index}.base_rate_foreign`}
                                                value={values.payment[index].base_rate_foreign}
                                                onChange={(e) => {
                                                  handleChange(e);
                                                }}
                                                error={Boolean(
                                                  touched.payment &&
                                                  touched?.payment[index]?.base_rate_foreign &&
                                                  errors.payment &&
                                                  errors?.payment[index]?.base_rate_foreign
                                                )}
                                                helperText={
                                                  touched.payment &&
                                                  touched?.payment[index]?.base_rate_foreign &&
                                                  errors.payment &&
                                                  errors?.payment[index]?.base_rate_foreign
                                                }
                                                variant="standard"
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <TextField
                                                sx={{ m: 1 }}
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                InputProps={{
                                                  startAdornment: (
                                                    <InputAdornment position="start">
                                                      %
                                                    </InputAdornment>
                                                  ),
                                                }}
                                                type="number"
                                                label="Markup Rate (Foreign Card)"
                                                id={`payment.${index}.markup_rate_foreign`}
                                                name={`payment.${index}.markup_rate_foreign`}
                                                value={values.payment[index].markup_rate_foreign}
                                                onChange={(e) => {
                                                  handleChange(e);
                                                }}
                                                error={Boolean(
                                                  touched.payment &&
                                                  touched?.payment[index]?.markup_rate_foreign &&
                                                  errors.payment &&
                                                  errors?.payment[index]?.markup_rate_foreign
                                                )}
                                                helperText={
                                                  touched.payment &&
                                                  touched?.payment[index]?.markup_rate_foreign &&
                                                  errors.payment &&
                                                  errors?.payment[index]?.markup_rate_foreign
                                                }
                                                variant="standard"
                                              />
                                            </Grid>
                                          </>
                                        )
                                      }

                                      {[PAYMENT_HOST_LIST.DBS, PAYMENT_HOST_LIST.SCB].includes(selectedPaymentHosts[index]) && paynowDescriptor &&
                                        <Grid item xs={4}>
                                          <Box sx={{ m: 1 }}>
                                            <Field
                                              name={`payment.${index}.paynow_descriptor_id`}
                                              validate={(value) => {
                                                if (value?.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  sx={{ pt: 0.5 }}
                                                  required
                                                  variant="standard"
                                                  name={`payment.${index}.paynow_descriptor_id`}
                                                  select
                                                  label="PayNow Descriptor"
                                                  size="small"
                                                  fullWidth
                                                  value={values.payment[index].paynow_descriptor_id}
                                                  onChange={(e, child) => {
                                                    setFieldValue(`payment.${index}.ref_2`, child.props["dataPayNowSuffix"]);
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[
                                                      index
                                                    ]?.paynow_descriptor_id &&
                                                    errors.payment &&
                                                    errors?.payment?.[index]
                                                      ?.paynow_descriptor_id
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.paynow_descriptor_id &&
                                                    errors.payment &&
                                                    errors?.payment?.[index]
                                                      ?.paynow_descriptor_id
                                                  }
                                                >
                                                  {paynowDescriptor[selectedPaymentHosts[index]]?.map((item) => (
                                                    <MenuItem
                                                      key={item.id}
                                                      value={item.id}
                                                      dataPayNowSuffix={item.paynow_proxy_suffix}
                                                    >
                                                      {item.name} - {item.paynow_proxy_suffix}
                                                    </MenuItem>
                                                  ))
                                                    || UnavailableOptionItem}
                                                </TextField>
                                              )}
                                            />
                                          </Box>
                                        </Grid>
                                      }

                                      {(selectedPaymentHosts[index] === PAYMENT_HOST_LIST.SCB || selectedPaymentHosts[index] === PAYMENT_HOST_LIST.DBS) &&
                                        <Grid item xs={2}>
                                          <Field
                                            name={`payment.${index}.ref_2`}
                                            render={({ field }) => (
                                              <TextField
                                                required
                                                sx={{ m: 1 }}
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                disabled
                                                label="PayNow Suffix"
                                                name={`payment.${index}.ref_2`}
                                                value={values.payment[index].ref_2}
                                                variant="standard"
                                              />
                                            )}
                                          />
                                        </Grid>
                                      }

                                      {selectedPaymentHosts[index] === PAYMENT_HOST_LIST.LIQUIDNET && (
                                        <>
                                          <Grid item xs={2}>
                                            <Box sx={{ m: 1 }}>
                                              <Field
                                                name={`payment.${index}.payee`}
                                                validate={(value) => {
                                                  if (!value || value === LIQUID_PAYEE_PREFIX) {
                                                    return "Payee is required for liquidnet";
                                                  }
                                                  if (value.length !== 15) {
                                                    return "Payee must be exactly 15 characters (" + LIQUID_PAYEE_PREFIX + " + 8 characters)";
                                                  }
                                                  return null;
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    size="small"
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    label="Payee"
                                                    name={`payment.${index}.payee`}
                                                    value={values.payment[index].payee?.replace(LIQUID_PAYEE_PREFIX, '') || ''}
                                                    onChange={(e) => {
                                                      const value = e.target.value;
                                                      if (value.length <= 8) {
                                                        setFieldValue(`payment.${index}.payee`, LIQUID_PAYEE_PREFIX + value);
                                                      }
                                                    }}
                                                    variant="standard"
                                                    placeholder=""
                                                    InputProps={{
                                                      startAdornment: (
                                                        <InputAdornment position="start">
                                                          <span
                                                            style={{
                                                              fontFamily: 'monospace',
                                                              fontSize: '15px',
                                                              fontWeight: 'normal',
                                                              color: 'inherit',
                                                              paddingBottom: '2px'
                                                            }}
                                                          >
                                                            {LIQUID_PAYEE_PREFIX}
                                                          </span>
                                                        </InputAdornment>
                                                      ),
                                                    }}
                                                    inputProps={{
                                                      maxLength: 8,
                                                      style: { fontFamily: 'monospace' }
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]?.payee &&
                                                      errors?.payment?.[index]?.payee
                                                    )}
                                                  />
                                                )}
                                              />
                                            </Box>
                                          </Grid>
                                        </>
                                      )}

                                      {selectedPaymentHosts[index] === PAYMENT_HOST_LIST.LINEPAY && (
                                        <Grid item xs={2}>
                                          <Box sx={{ m: 1 }}>
                                            <Field
                                              name={`payment.${index}.line_pay_merchant_id`}
                                              validate={(value) => {
                                                if (!value) return "LINE Pay Merchant ID is required for PromptPay";
                                                if (value.length > 100) return "LINE Pay Merchant ID must be at most 100 characters";
                                                return null;
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  size="small"
                                                  InputLabelProps={{ shrink: true }}
                                                  label="LINE Pay Merchant ID"
                                                  name={`payment.${index}.line_pay_merchant_id`}
                                                  value={values.payment[index].line_pay_merchant_id ?? ""}
                                                  onChange={(e) => setFieldValue(`payment.${index}.line_pay_merchant_id`, e.target.value)}
                                                  variant="standard"
                                                  inputProps={{ maxLength: 100 }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]?.line_pay_merchant_id &&
                                                    errors?.payment?.[index]?.line_pay_merchant_id
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]?.line_pay_merchant_id &&
                                                    errors?.payment?.[index]?.line_pay_merchant_id
                                                  }
                                                />
                                              )}
                                            />
                                          </Box>
                                        </Grid>
                                      )}

                                      {selectedPaymentHosts[index] === PAYMENT_HOST_LIST.FOMOPAY && (
                                        <Grid item xs={2}>
                                          <Box sx={{ m: 1 }}>
                                            <Field
                                              name={`payment.${index}.sub_mid`}
                                              validate={(value) => {
                                                if (value && value.length > 128) return "Sub MID must be at most 128 characters";
                                                return null;
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  size="small"
                                                  InputLabelProps={{ shrink: true }}
                                                  label="Sub MID"
                                                  name={`payment.${index}.sub_mid`}
                                                  value={values.payment[index].sub_mid ?? ""}
                                                  onChange={(e) =>
                                                    setFieldValue(`payment.${index}.sub_mid`, e.target.value)
                                                  }
                                                  variant="standard"
                                                  inputProps={{ maxLength: 128 }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]?.sub_mid &&
                                                    errors?.payment?.[index]?.sub_mid
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]?.sub_mid &&
                                                    errors?.payment?.[index]?.sub_mid
                                                  }
                                                />
                                              )}
                                            />
                                          </Box>
                                        </Grid>
                                      )}

                                      {selectedPaymentHosts[index] === PAYMENT_HOST_LIST.ATOME && (
                                        <>
                                          <Grid item xs={2}>
                                            <Box sx={{ m: 1 }}>
                                              <Field
                                                name={`payment.${index}.atome_username`}
                                                validate={(value) => {
                                                  if (!showAtomeDynamicField(selectedPaymentHosts[index])) return null;
                                                  const v = value != null ? String(value).trim() : "";
                                                  if (!v) return "Username is required for Atome";
                                                  if (v.length > 50) return "Username must be at most 50 characters";
                                                  return null;
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    size="small"
                                                    InputLabelProps={{ shrink: true }}
                                                    label="Atome username"
                                                    name={`payment.${index}.atome_username`}
                                                    value={values.payment[index].atome_username ?? ""}
                                                    onChange={(e) =>
                                                      setFieldValue(`payment.${index}.atome_username`, e.target.value)
                                                    }
                                                    variant="standard"
                                                    inputProps={{ maxLength: 50 }}
                                                    autoComplete="off"
                                                    error={Boolean(
                                                      touched.payment &&
                                                        touched?.payment[index]?.atome_username &&
                                                        errors?.payment?.[index]?.atome_username
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                        touched?.payment[index]?.atome_username &&
                                                        errors?.payment?.[index]?.atome_username
                                                    }
                                                  />
                                                )}
                                              />
                                            </Box>
                                          </Grid>
                                          <Grid item xs={2}>
                                            <Box sx={{ m: 1 }}>
                                              <Field
                                                name={`payment.${index}.atome_password`}
                                                validate={(value) => {
                                                  if (!showAtomeDynamicField(selectedPaymentHosts[index])) return null;
                                                  const v = value != null ? String(value).trim() : "";
                                                  if (!v) return "Password is required for Atome";
                                                  if (v.length > 255) return "Password must be at most 255 characters";
                                                  return null;
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    size="small"
                                                    type="text"
                                                    InputLabelProps={{ shrink: true }}
                                                    label="Atome password"
                                                    name={`payment.${index}.atome_password`}
                                                    value={values.payment[index].atome_password ?? ""}
                                                    onChange={(e) =>
                                                      setFieldValue(`payment.${index}.atome_password`, e.target.value)
                                                    }
                                                    variant="standard"
                                                    inputProps={{ maxLength: 255 }}
                                                    autoComplete="off"
                                                    error={Boolean(
                                                      touched.payment &&
                                                        touched?.payment[index]?.atome_password &&
                                                        errors?.payment?.[index]?.atome_password
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                        touched?.payment[index]?.atome_password &&
                                                        errors?.payment?.[index]?.atome_password
                                                    }
                                                  />
                                                )}
                                              />
                                            </Box>
                                          </Grid>
                                        </>
                                      )}

                                      {selectedPaymentHosts[index] &&
                                        showGrabPayDynamicField(
                                          selectedPaymentHosts[index]
                                        ) && !selectedPaymentHosts[index]?.includes(PAYMENT_HOST_LIST.GRABPAY_GW2) && (
                                          <>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.grabpay_merchant_id`}
                                                id={`payment.${index}.grabpay_merchant_id`}
                                                validate={(value) => {
                                                  if (value?.length < 1) {
                                                    return "GrabPay Store ID is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    label="GrabPay Store ID"
                                                    id={`payment.${index}.grabpay_merchant_id`}
                                                    name={`payment.${index}.grabpay_merchant_id`}
                                                    value={
                                                      values.payment[index]
                                                        ?.grabpay_merchant_id
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched.payment[
                                                      index
                                                      ] &&
                                                      touched.payment[index]
                                                        ?.grabpay_merchant_id &&
                                                      errors.payment &&
                                                      errors.payment[index]
                                                        ?.grabpay_merchant_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.grabpay_merchant_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.grabpay_merchant_id
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>

                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.grabpay_terminal_id`}
                                                id={`payment.${index}.grabpay_terminal_id`}
                                                validate={(value) => {
                                                  if (value?.length < 1) {
                                                    return "GrabPay Terminal ID id is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    label="GrabPay Terminal ID"
                                                    id={`payment.${index}.grabpay_terminal_id`}
                                                    name={`payment.${index}.grabpay_terminal_id`}
                                                    value={
                                                      values.payment[index]
                                                        ?.grabpay_terminal_id
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.grabpay_terminal_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.grabpay_terminal_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.grabpay_terminal_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.grabpay_terminal_id
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            {!selectedPaymentHosts[index]
                                              ?.toLowerCase()
                                              ?.includes(PAYMENT_HOST_LIST.GRABPAY_V1) && (
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.payment_expiry_time`}
                                                  id={`payment.${index}.payment_expiry_time`}
                                                  validate={(value) => {
                                                    if (value?.length < 1) {
                                                      return "Payment Expiry Time is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      InputProps={{
                                                        min: 0,
                                                        step: "any"
                                                      }}
                                                      type="number"
                                                      label="Payment Expiry Time (Min)"
                                                      id={`payment.${index}.payment_expiry_time`}
                                                      name={`payment.${index}.payment_expiry_time`}
                                                      value={
                                                        values.payment[index]
                                                          ?.payment_expiry_time
                                                      }
                                                      onChange={(event) => {
                                                        const value = event.target.value;

                                                        // Allow empty value so user can clear the input
                                                        if (value === "") {
                                                          handleChange(event);
                                                          return;
                                                        }

                                                        // Prevent negative number
                                                        if (Number(value) < 0) {
                                                          return;
                                                        }

                                                        handleChange(event);
                                                      }}
                                                      onKeyDown={(event) => {
                                                        // Prevent negative, positive sign, and exponential input
                                                        if (["-", "+", "e", "E"].includes(event.key)) {
                                                          event.preventDefault();
                                                        }
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                          touched?.payment[index]
                                                            ?.payment_expiry_time &&
                                                          errors.payment &&
                                                          errors?.payment[index]
                                                            ?.payment_expiry_time
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                          touched?.payment[index]
                                                            ?.payment_expiry_time &&
                                                          errors.payment &&
                                                          errors?.payment[index]
                                                            ?.payment_expiry_time
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                            )}
                                            {!selectedPaymentHosts[index]
                                              ?.toLowerCase()
                                              ?.includes(PAYMENT_HOST_LIST.GRABPAY_V1) && (
                                              <>
                                                <Grid item xs={2}>
                                                  <Field
                                                    name={`payment.${index}.min_amt_postpaid`}
                                                    id={`payment.${index}.min_amt_postpaid`}
                                                    validate={(value) => {
                                                      if (values.payment[index]?.postpaid) {
                                                        if (value?.length < 1) {
                                                          return "Min Amount (Postpaid) is required";
                                                        }
                                                      }
                                                    }}
                                                    render={({ field }) => (
                                                      <TextField
                                                        required={values.payment[index]?.postpaid}
                                                        sx={{ m: 1 }}
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                        type="number"
                                                        InputProps={{
                                                          min: 0,
                                                          step: "any",
                                                          startAdornment: (
                                                            <InputAdornment position="start">
                                                              $
                                                            </InputAdornment>
                                                          ),
                                                        }}
                                                        label="Min Amount (Postpaid)"
                                                        id={`payment.${index}.min_amt_postpaid`}
                                                        name={`payment.${index}.min_amt_postpaid`}
                                                        value={
                                                          values.payment[index]
                                                            ?.min_amt_postpaid
                                                        }
                                                        onChange={(event) => {
                                                          const value = event.target.value;

                                                          // Allow empty value so user can clear the input
                                                          if (value === "") {
                                                            handleChange(event);
                                                            return;
                                                          }

                                                          // Prevent negative number
                                                          if (Number(value) < 0) {
                                                            return;
                                                          }

                                                          handleChange(event);
                                                        }}
                                                        onKeyDown={(event) => {
                                                          // Prevent negative, positive sign, and exponential input
                                                          if (["-", "+", "e", "E"].includes(event.key)) {
                                                            event.preventDefault();
                                                          }
                                                        }}
                                                        error={Boolean(
                                                          touched.payment &&
                                                            touched?.payment[index]
                                                              ?.min_amt_postpaid &&
                                                            errors.payment &&
                                                            errors?.payment[index]
                                                              ?.min_amt_postpaid
                                                        )}
                                                        helperText={
                                                          touched.payment &&
                                                            touched?.payment[index]
                                                              ?.min_amt_postpaid &&
                                                            errors.payment &&
                                                            errors?.payment[index]
                                                              ?.min_amt_postpaid
                                                        }
                                                        variant="standard"
                                                      />
                                                    )}
                                                  />
                                                </Grid>
                                                <Grid item xs={2}>
                                                  <Field
                                                    name={`payment.${index}.min_amt_installment_4`}
                                                    id={`payment.${index}.min_amt_installment_4`}
                                                    validate={(value) => {
                                                      if (values.payment[index]?.installment_4) {
                                                        if (value?.length < 1) {
                                                          return "Min Amount (Installment) is required";
                                                        }
                                                      }
                                                    }}
                                                    render={({ field }) => (
                                                      <TextField
                                                        required={
                                                          !!values.payment[index]
                                                            ?.min_amt_installment_4
                                                        }
                                                        sx={{ m: 1 }}
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                        type="number"
                                                        InputProps={{
                                                          min: 0,
                                                          step: "any",
                                                          startAdornment: (
                                                            <InputAdornment position="start">
                                                              $
                                                            </InputAdornment>
                                                          ),
                                                        }}
                                                        label="Min Amount (Installment)"
                                                        id={`payment.${index}.min_amt_installment_4`}
                                                        name={`payment.${index}.min_amt_installment_4`}
                                                        value={
                                                          values.payment[index]
                                                            ?.min_amt_installment_4
                                                        }
                                                        onChange={(event) => {
                                                          const value = event.target.value;

                                                          // Allow empty value so user can clear the input
                                                          if (value === "") {
                                                            handleChange(event);
                                                            return;
                                                          }

                                                          // Prevent negative number
                                                          if (Number(value) < 0) {
                                                            return;
                                                          }

                                                          handleChange(event);
                                                        }}
                                                        onKeyDown={(event) => {
                                                          // Prevent negative, positive sign, and exponential input
                                                          if (["-", "+", "e", "E"].includes(event.key)) {
                                                            event.preventDefault();
                                                          }
                                                        }}
                                                        error={Boolean(
                                                          touched.payment &&
                                                            touched?.payment[index]
                                                              ?.min_amt_installment_4 &&
                                                            errors.payment &&
                                                            errors?.payment[index]
                                                              ?.min_amt_installment_4
                                                        )}
                                                        helperText={
                                                          touched.payment &&
                                                            touched?.payment[index]
                                                              ?.min_amt_installment_4 &&
                                                            errors.payment &&
                                                            errors?.payment[index]
                                                              ?.min_amt_installment_4
                                                        }
                                                        variant="standard"
                                                      />
                                                    )}
                                                  />
                                                </Grid>
                                              </>
                                            )}
                                          </>
                                        )}
                                      {/* Begin TouchNGo */}
                                      {selectedPaymentHosts[index] &&
                                        showTouchNGoDynamicField(
                                          selectedPaymentHosts[index]
                                        ) && (
                                          <>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.touchngo_expiry_time`}
                                                id={`payment.${index}.touchngo_expiry_time`}
                                                validate={(value) => {
                                                  if (value?.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    label="Expiry Time (Min)"
                                                    id={`payment.${index}.touchngo_expiry_time`}
                                                    name={`payment.${index}.touchngo_expiry_time`}
                                                    value={
                                                      values.payment[index]
                                                        .touchngo_expiry_time
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.touchngo_expiry_time &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.touchngo_expiry_time
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.touchngo_expiry_time &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.touchngo_expiry_time
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.touchngo_merchant_id`}
                                                id={`payment.${index}.touchngo_merchant_id`}
                                                validate={(value) => {
                                                  if (value?.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    label="TouchNGo Merchant ID"
                                                    id={`payment.${index}.touchngo_merchant_id`}
                                                    name={`payment.${index}.touchngo_merchant_id`}
                                                    value={
                                                      values.payment[index].touchngo_merchant_id
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.touchngo_merchant_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.touchngo_merchant_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.touchngo_merchant_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.touchngo_merchant_id
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.touchngo_client_id`}
                                                id={`payment.${index}.touchngo_client_id`}
                                                validate={(value) => {
                                                  if (value?.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    label="TouchNGo Client ID"
                                                    id={`payment.${index}.touchngo_client_id`}
                                                    name={`payment.${index}.touchngo_client_id`}
                                                    value={
                                                      values.payment[index].touchngo_client_id
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.touchngo_client_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.touchngo_client_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.touchngo_client_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.touchngo_client_id
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.touchngo_client_secret`}
                                                id={`payment.${index}.touchngo_client_secret`}
                                                validate={(value) => {
                                                  if (value.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    label="TouchNGo Client Secret"
                                                    id={`payment.${index}.touchngo_client_secret`}
                                                    name={`payment.${index}.touchngo_client_secret`}
                                                    value={
                                                      values.payment[index].touchngo_client_secret
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.touchngo_client_secret &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.touchngo_client_secret
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.touchngo_client_secret &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.touchngo_client_secret
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.is_autodebit_enabled`}
                                                id={`payment.${index}.is_autodebit_enabled`}
                                                render={({ field }) => (
                                                  <FormControlLabel
                                                    sx={{ m: 1 }}
                                                    control={
                                                      <Checkbox
                                                        id={`payment.${index}.is_autodebit_enabled`}
                                                        name={`payment.${index}.is_autodebit_enabled`}
                                                        checked={Boolean(
                                                          values.payment[index]
                                                            .is_autodebit_enabled
                                                        )}
                                                        onChange={(e) => {
                                                          setFieldValue(
                                                            `payment.${index}.is_autodebit_enabled`,
                                                            e.target.checked
                                                          );
                                                          if (!e.target.checked) {
                                                            setFieldValue(
                                                              `payment.${index}.autodebit_amount`,
                                                              ""
                                                            );
                                                          }
                                                        }}
                                                      />
                                                    }
                                                    label="Enable AutoDebit"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            {values.payment[index]
                                              .is_autodebit_enabled && (
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.autodebit_amount`}
                                                  id={`payment.${index}.autodebit_amount`}
                                                  validate={(value) => {
                                                    if (
                                                      values.payment[index]
                                                        .is_autodebit_enabled &&
                                                      (value === undefined ||
                                                        value === null ||
                                                        value === "")
                                                    ) {
                                                      return "AutoDebit Amount is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      required
                                                      sx={{ m: 1 }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      type="number"
                                                      label="AutoDebit Amount"
                                                      id={`payment.${index}.autodebit_amount`}
                                                      name={`payment.${index}.autodebit_amount`}
                                                      value={
                                                        values.payment[index]
                                                          .autodebit_amount
                                                      }
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                      }}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.autodebit_amount &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.autodebit_amount
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]
                                                          ?.autodebit_amount &&
                                                        errors.payment &&
                                                        errors?.payment[index]
                                                          ?.autodebit_amount
                                                      }
                                                      variant="standard"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                            )}
                                          </>
                                        )}
                                      {selectedPaymentHosts[index] &&
                                        showDashDynamicField(
                                          selectedPaymentHosts[index]
                                        ) && (
                                          <>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.counter_id`}
                                                id={`payment.${index}.counter_id`}
                                                validate={(value) => {
                                                  if (!value || String(value).trim() === '') {
                                                    return "Counter ID is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    label="Counter ID"
                                                    id={`payment.${index}.counter_id`}
                                                    name={`payment.${index}.counter_id`}
                                                    value={
                                                      values.payment[index].counter_id || ""
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.counter_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.counter_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.counter_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.counter_id
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.counter_msisdn`}
                                                id={`payment.${index}.counter_msisdn`}
                                                render={({ field }) => (
                                                  <TextField
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    label="Counter MSISDN"
                                                    id={`payment.${index}.counter_msisdn`}
                                                    name={`payment.${index}.counter_msisdn`}
                                                    value={
                                                      values.payment[index]?.counter_msisdn
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.counter_msisdn &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.counter_msisdn
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.counter_msisdn &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.counter_msisdn
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.counter_pin`}
                                                id={`payment.${index}.counter_pin`}
                                                render={({ field }) => (
                                                  <TextField
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    label="Counter PIN"
                                                    id={`payment.${index}.counter_pin`}
                                                    name={`payment.${index}.counter_pin`}
                                                    value={
                                                      values.payment[index]?.counter_pin
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.counter_pin &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.counter_pin
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.counter_pin &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.counter_pin
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                          </>
                                        )}
                                      {selectedPaymentHosts[index] &&
                                        showAliPayDynamicField(
                                          selectedPaymentHosts[index]
                                        ) && (
                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.store_id`}
                                              id={`payment.${index}.store_id`}
                                              validate={(value) => {
                                                if (!value || String(value).trim() === "") {
                                                  return "Store ID is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{ shrink: true }}
                                                  label="Store ID"
                                                  id={`payment.${index}.store_id`}
                                                  name={`payment.${index}.store_id`}
                                                  value={values.payment[index].store_id || ""}
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]?.store_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.store_id
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]?.store_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.store_id
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>
                                        )}
                                      {selectedPaymentHosts[index] &&
                                        showWeChatDynamicField(
                                          selectedPaymentHosts[index]
                                        ) && (
                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.partner_id`}
                                              id={`payment.${index}.partner_id`}
                                              validate={(value) => {
                                                if (!value || String(value).trim() === "") {
                                                  return "Partner ID is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{ shrink: true }}
                                                  label="Partner ID"
                                                  id={`payment.${index}.partner_id`}
                                                  name={`payment.${index}.partner_id`}
                                                  value={values.payment[index].partner_id || ""}
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]?.partner_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.partner_id
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]?.partner_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.partner_id
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>
                                        )}
                                      {selectedPaymentHosts[index] &&
                                        showWorldPayDynamicField(
                                          selectedPaymentHosts[index]
                                        ) && (
                                          <>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.pf_id`}
                                                id={`payment.${index}.pf_id`}
                                                validate={(value) => {
                                                  if (value?.length < 1) {
                                                    return "Sub Merchant pf id is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    label="Sub Merchant pf id"
                                                    id={`payment.${index}.pf_id`}
                                                    name={`payment.${index}.pf_id`}
                                                    value={
                                                      values.payment[index]
                                                        ?.pf_id
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.pf_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.pf_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.pf_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.pf_id
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.sub_name`}
                                                id={`payment.${index}.sub_name`}
                                                validate={(value) => {
                                                  if (value?.length < 1) {
                                                    return "Sub Merchant Name is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    label="Sub Merchant Name"
                                                    id={`payment.${index}.sub_name`}
                                                    name={`payment.${index}.sub_name`}
                                                    value={
                                                      values.payment[index]
                                                        ?.sub_name
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.sub_name &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.sub_name
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.sub_name &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.sub_name
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.sub_id`}
                                                id={`payment.${index}.sub_id`}
                                                validate={(value) => {
                                                  if (value?.length < 1) {
                                                    return "Sub Merchant Id is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    label="Sub Merchant Id"
                                                    id={`payment.${index}.sub_id`}
                                                    name={`payment.${index}.sub_id`}
                                                    value={
                                                      values.payment[index]
                                                        ?.sub_id
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.sub_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.sub_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.sub_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.sub_id
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.sub_street`}
                                                id={`payment.${index}.sub_street`}
                                                validate={(value) => {
                                                  if (value?.length < 1) {
                                                    return "Sub Merchant Street is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    label="Sub Merchant Street"
                                                    id={`payment.${index}.sub_street`}
                                                    name={`payment.${index}.sub_street`}
                                                    value={
                                                      values.payment[index]
                                                        ?.sub_street
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.sub_street &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.sub_street
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.sub_street &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.sub_street
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.sub_city`}
                                                id={`payment.${index}.sub_city`}
                                                validate={(value) => {
                                                  if (value?.length < 1) {
                                                    return "Sub Merchant City is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    label="Sub Merchant City"
                                                    id={`payment.${index}.sub_city`}
                                                    name={`payment.${index}.sub_city`}
                                                    value={
                                                      values.payment[index]
                                                        ?.sub_city
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.sub_city &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.sub_city
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.sub_city &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.sub_city
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.sub_country_code`}
                                                id={`payment.${index}.sub_country_code`}
                                                validate={(value) => {
                                                  if (value?.length < 1) {
                                                    return "Sub Merchant Country Code is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1, width: "100%" }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    select
                                                    label="Sub Merchant Country Code"
                                                    id={`payment.${index}.sub_country_code`}
                                                    name={`payment.${index}.sub_country_code`}
                                                    value={
                                                      values.payment[index]
                                                        ?.sub_country_code
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched.payment[
                                                      index
                                                      ] &&
                                                      touched.payment[index]
                                                        ?.sub_country_code &&
                                                      errors.payment &&
                                                      errors.payment[index]
                                                        ?.sub_country_code
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.sub_country_code &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.sub_country_code
                                                    }
                                                    variant="standard"
                                                  >
                                                    {
                                                      SUB_MERCHANT_COUNTRY_CODE.map((item) => (
                                                        <MenuItem
                                                          key={item.id}
                                                          value={item.id}
                                                        >
                                                          {item.id} - {item.name}
                                                        </MenuItem>
                                                      ))
                                                    }
                                                  </TextField>
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.sub_postal_code`}
                                                id={`payment.${index}.sub_postal_code`}
                                                validate={(value) => {
                                                  if (value?.length < 1) {
                                                    return "Sub Merchant Postal Code is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.sub_postal_code`}
                                                    name={`payment.${index}.sub_postal_code`}
                                                    label="Sub Merchant Postal Code"
                                                    value={
                                                      values.payment[index]
                                                        ?.sub_postal_code
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.sub_postal_code &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.sub_postal_code
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.sub_postal_code &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.sub_postal_code
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.mcc`}
                                                id={`payment.${index}.mcc`}
                                                validate={(value) => {
                                                  if (value?.length < 1) {
                                                    return "MCC is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.mcc`}
                                                    name={`payment.${index}.mcc`}
                                                    label="MCC"
                                                    value={
                                                      values.payment[index]?.mcc
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.mcc &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.mcc
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.mcc &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.mcc
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            {values.payment[index]
                                              ?.enable_vis && (
                                                <Grid item xs={2}>
                                                  <Field
                                                    name={`payment.${index}.partner_merchant_reference_id`}
                                                    id={`payment.${index}.partner_merchant_reference_id`}
                                                    validate={(value) => {
                                                      if (value?.length < 1) {
                                                        return "Partner Merchant Reference id is required";
                                                      }
                                                    }}
                                                    render={({ field }) => (
                                                      <TextField
                                                        required
                                                        sx={{ m: 1 }}
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                        label="Partner Merchant Reference id"
                                                        id={`payment.${index}.partner_merchant_reference_id`}
                                                        name={`payment.${index}.partner_merchant_reference_id`}
                                                        value={
                                                          values.payment[index]
                                                            ?.partner_merchant_reference_id
                                                        }
                                                        onChange={(e) => {
                                                          handleChange(e);
                                                        }}
                                                        error={Boolean(
                                                          touched.payment &&
                                                          touched?.payment[
                                                            index
                                                          ]
                                                            ?.partner_merchant_reference_id &&
                                                          errors.payment &&
                                                          errors?.payment[index]
                                                            ?.partner_merchant_reference_id
                                                        )}
                                                        helperText={
                                                          touched.payment &&
                                                          touched?.payment[index]
                                                            ?.partner_merchant_reference_id &&
                                                          errors.payment &&
                                                          errors?.payment[index]
                                                            ?.partner_merchant_reference_id
                                                        }
                                                        variant="standard"
                                                      />
                                                    )}
                                                  />
                                                </Grid>
                                              )}

                                            {/* {values.payment[index]
                                              ?.enable_vis && (
                                                <Grid item xs={4}>
                                                  <Box sx={{ m: 1 }}>
                                                    <Field
                                                      id={`payment.${index}.currency_list`}
                                                      name={`payment.${index}.currency_list`}
                                                      value={
                                                        values.payment[index]
                                                          ?.currency_list
                                                      }
                                                      options={allowedCurrency.map(
                                                        (method) => ({
                                                          value: method.id || "",
                                                          label:
                                                            method.currency || "",
                                                        })
                                                      )}
                                                      placeholder="Select multi currencies..."
                                                      component={MultiSelectField}
                                                      validate={(value) => {
                                                        if (value?.length < 1) {
                                                          return "At least one currency must be selected";
                                                        }
                                                      }}
                                                    />
                                                    {touched.payment &&
                                                      touched?.payment[index]
                                                        ?.currency_list &&
                                                      errors.payment &&
                                                      errors?.payment[index]
                                                        ?.currency_list ? (
                                                      <div
                                                        style={{
                                                          color: "red",
                                                          fontSize: "12px",
                                                        }}
                                                      >
                                                        {
                                                          errors?.payment[index]
                                                            ?.currency_list
                                                        }
                                                      </div>
                                                    ) : null}
                                                  </Box>
                                                </Grid>
                                              )} */}
                                            {values.payment[index]
                                              ?.enable_vis && (
                                                <Grid item xs={2}>
                                                  <FormControlLabel
                                                    sx={{ m: 1 }}
                                                    type="checkbox"
                                                    id={`payment.${index}.enabled_3ds`}
                                                    name={`payment.${index}.enabled_3ds`}
                                                    checked={
                                                      values.payment[index]
                                                        .enabled_3ds
                                                    }
                                                    onChange={() =>
                                                      setFieldValue(
                                                        `payment.${index}.enabled_3ds`,
                                                        !values.payment[index]
                                                          .enabled_3ds
                                                      )
                                                    }
                                                    control={<Checkbox />}
                                                    label="Enable 3DS"
                                                  />
                                                </Grid>
                                              )}
                                            {!values.payment[index]
                                              ?.default_bin_routing && (
                                                <Grid item xs={2}>
                                                  <Field
                                                    name={`payment.${index}.min_card_range`}
                                                    id={`payment.${index}.min_card_range`}
                                                    validate={(value) => {
                                                      if (value?.length < 1) {
                                                        return "Min Card Range is required";
                                                      }
                                                    }}
                                                    render={({ field }) => (
                                                      <TextField
                                                        required
                                                        sx={{ m: 1 }}
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                        InputProps={{
                                                          startAdornment: (
                                                            <InputAdornment position="start">
                                                              $
                                                            </InputAdornment>
                                                          ),
                                                        }}
                                                        label="Min Card Range"
                                                        id={`payment.${index}.min_card_range`}
                                                        name={`payment.${index}.min_card_range`}
                                                        value={
                                                          values.payment[index]
                                                            ?.min_card_range
                                                        }
                                                        onChange={(e) => {
                                                          handleChange(e);
                                                        }}
                                                        error={Boolean(
                                                          touched.payment &&
                                                          touched?.payment[
                                                            index
                                                          ]?.min_card_range &&
                                                          errors.payment &&
                                                          errors?.payment[index]
                                                            ?.min_card_range
                                                        )}
                                                        helperText={
                                                          touched.payment &&
                                                          touched?.payment[index]
                                                            ?.min_card_range &&
                                                          errors.payment &&
                                                          errors?.payment[index]
                                                            ?.min_card_range
                                                        }
                                                        variant="standard"
                                                      />
                                                    )}
                                                  />
                                                </Grid>
                                              )}
                                            {!values.payment[index]
                                              ?.default_bin_routing && (
                                                <Grid item xs={2}>
                                                  <Field
                                                    name={`payment.${index}.max_card_range`}
                                                    id={`payment.${index}.max_card_range`}
                                                    validate={(value) => {
                                                      if (value?.length < 1) {
                                                        return "Max Card Range is required";
                                                      }
                                                    }}
                                                    render={({ field }) => (
                                                      <TextField
                                                        required
                                                        sx={{ m: 1 }}
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                        InputProps={{
                                                          startAdornment: (
                                                            <InputAdornment position="start">
                                                              $
                                                            </InputAdornment>
                                                          ),
                                                        }}
                                                        label="Max Card Range"
                                                        id={`payment.${index}.max_card_range`}
                                                        name={`payment.${index}.max_card_range`}
                                                        value={
                                                          values.payment[index]
                                                            ?.max_card_range
                                                        }
                                                        onChange={(e) => {
                                                          handleChange(e);
                                                        }}
                                                        error={Boolean(
                                                          touched.payment &&
                                                          touched?.payment[
                                                            index
                                                          ]?.max_card_range &&
                                                          errors.payment &&
                                                          errors?.payment[index]
                                                            ?.max_card_range
                                                        )}
                                                        helperText={
                                                          touched.payment &&
                                                          touched?.payment[index]
                                                            ?.max_card_range &&
                                                          errors.payment &&
                                                          errors?.payment[index]
                                                            ?.max_card_range
                                                        }
                                                        variant="standard"
                                                      />
                                                    )}
                                                  />
                                                </Grid>
                                              )}
                                          </>
                                        )}

                                      {paymentMethod?.[index]?.toLowerCase() === "card" &&
                                        !showCybersourceDynamicField(selectedPaymentHosts[index]) && (
                                          <>
                                            <Grid item xs={2}>
                                              <Box sx={{ m: 1 }}>
                                                <Field
                                                  name={`payment.${index}.mpi_type`}
                                                  validate={(value) => {
                                                    if (value?.length < 1) {
                                                      return "This field is required";
                                                    }
                                                  }}
                                                  render={({ field }) => (
                                                    <TextField
                                                      sx={{ pt: 0.5 }}
                                                      required
                                                      variant="standard"
                                                      name={`payment.${index}.mpi_type`}
                                                      select
                                                      label="MPI Type"
                                                      size="small"
                                                      fullWidth
                                                      value={values.payment[index].mpi_type}
                                                      onChange={handleChange}
                                                      error={Boolean(
                                                        touched.payment &&
                                                        touched?.payment[index]?.mpi_type &&
                                                        errors.payment &&
                                                        errors?.payment?.[index]?.mpi_type
                                                      )}
                                                      helperText={
                                                        touched.payment &&
                                                        touched?.payment[index]?.mpi_type &&
                                                        errors.payment &&
                                                        errors?.payment?.[index]?.mpi_type
                                                      }
                                                    >
                                                      {MPI_TYPE_LIST.map((item) => (
                                                        <MenuItem key={item.id} value={item.id}>
                                                          {item.name}
                                                        </MenuItem>
                                                      )) || UnavailableOptionItem}
                                                    </TextField>
                                                  )}
                                                />
                                              </Box>
                                            </Grid>

                                            {+values.payment[index].mpi_type !== 0 && (
                                              <Grid item xs={4}>
                                                <Box sx={{ m: 1 }}>
                                                  <Field
                                                    name={`payment.${index}.mpi_id`}
                                                    validate={(value) => {
                                                      if (value?.length < 1) {
                                                        return "This field is required";
                                                      }
                                                    }}
                                                    render={({ field }) => (
                                                      <TextField
                                                        sx={{ pt: 0.5 }}
                                                        required
                                                        variant="standard"
                                                        name={`payment.${index}.mpi_id`}
                                                        select
                                                        label="MPI (Acquirer Bin - Acquirer Merchant ID)"
                                                        size="small"
                                                        fullWidth
                                                        value={values.payment[index].mpi_id}
                                                        onChange={handleChange}
                                                        error={Boolean(
                                                          touched.payment &&
                                                          touched?.payment[index]?.mpi_id &&
                                                          errors.payment &&
                                                          errors?.payment?.[index]?.mpi_id
                                                        )}
                                                        helperText={
                                                          touched.payment &&
                                                          touched?.payment[index]?.mpi_id &&
                                                          errors.payment &&
                                                          errors?.payment?.[index]?.mpi_id
                                                        }
                                                      >
                                                        {mpiList?.map((item) => (
                                                          <MenuItem key={item.id} value={item.id}>
                                                            {item.acquirer_bin} - {item.acquirer_merchant_id}
                                                          </MenuItem>
                                                        )) || UnavailableOptionItem}
                                                      </TextField>
                                                    )}
                                                  />
                                                </Box>
                                              </Grid>
                                            )}
                                          </>
                                        )}
                                    </Grid>

                                    <FiuuFixedFeeFields
                                      index={index}
                                      values={values}
                                      handleChange={handleChange}
                                      touched={touched}
                                      errors={errors}
                                      selectedPaymentHost={selectedPaymentHosts[index]}
                                    />

                                    {selectedPaymentHosts[index] &&
                                      showGrabPayDynamicField(
                                        selectedPaymentHosts[index]
                                      ) &&
                                      !selectedPaymentHosts[index]?.toLowerCase()?.includes(PAYMENT_HOST_LIST.GRABPAY_GW2) &&
                                      !selectedPaymentHosts[index]?.toLowerCase()?.includes(PAYMENT_HOST_LIST.GRABPAY_V1) && (
                                        <Grid
                                          container
                                          column={6}
                                          alignItems="flex-end"
                                        >

                                          {!selectedPaymentHosts[index]?.toLowerCase().includes(PAYMENT_HOST_LIST.GRABPAY_SG) && (
                                            <Grid item xs={2}>
                                              <FormControlLabel
                                                sx={{ m: 1 }}
                                                type="checkbox"
                                                id={`payment.${index}.postpaid`}
                                                name={`payment.${index}.postpaid`}
                                                checked={
                                                  values.payment[index].postpaid
                                                }
                                                onChange={() =>
                                                  setFieldValue(
                                                    `payment.${index}.postpaid`,
                                                    !values.payment[index]
                                                      .postpaid
                                                  )
                                                }
                                                control={<Checkbox />}
                                                label="Postpaid"
                                              />
                                            </Grid>
                                          )}
                                          <Grid item xs={2}>
                                            <FormControlLabel
                                              sx={{ m: 1 }}
                                              type="checkbox"
                                              id={`payment.${index}.installment_4`}
                                              name={`payment.${index}.installment_4`}
                                              checked={
                                                values.payment[index]
                                                  .installment_4
                                              }
                                              onChange={() =>
                                                setFieldValue(
                                                  `payment.${index}.installment_4`,
                                                  !values.payment[index]
                                                    .installment_4
                                                )
                                              }
                                              control={<Checkbox />}
                                              label="Installment"
                                            />
                                          </Grid>
                                          {(selectedPaymentHosts[index] &&
                                            selectedPaymentHosts[index]?.toLowerCase().includes(PAYMENT_HOST_LIST.GRABPAY_SG) &&
                                            values.payment[index].installment_4) && (
                                              <>
                                                <Grid item xs={2}>
                                                  <Field
                                                    name={`payment.${index}.base_rate_installment`}
                                                    id={`payment.${index}.base_rate_installment`}
                                                    validate={(value) => {
                                                      if (
                                                        values.payment[index]
                                                          .installment_4
                                                      ) {
                                                        if (value?.length === 0) {
                                                          return "This field is required";
                                                        }
                                                      }
                                                    }}
                                                    render={({ field }) => (
                                                      <TextField
                                                        required
                                                        sx={{ m: 1 }}
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                        InputProps={{
                                                          startAdornment: (
                                                            <InputAdornment position="start">
                                                              %
                                                            </InputAdornment>
                                                          ),
                                                        }}
                                                        label="Base Rate (Installment)"
                                                        id={`payment.${index}.base_rate_installment`}
                                                        name={`payment.${index}.base_rate_installment`}
                                                        value={values.payment[index].base_rate_installment}
                                                        onChange={(e) => {
                                                          handleChange(e);
                                                        }}
                                                        type="number"
                                                        error={Boolean(
                                                          touched.payment &&
                                                          touched?.payment[index]?.base_rate_installment &&
                                                          errors.payment &&
                                                          errors?.payment[index]?.base_rate_installment
                                                        )}
                                                        helperText={
                                                          touched.payment &&
                                                          touched?.payment[index]?.base_rate_installment &&
                                                          errors.payment &&
                                                          errors?.payment[index]?.base_rate_installment
                                                        }
                                                        variant="standard"
                                                      />
                                                    )}
                                                  />
                                                </Grid>
                                                <Grid item xs={2}>
                                                  <Field
                                                    name={`payment.${index}.markup_rate_installment`}
                                                    id={`payment.${index}.markup_rate_installment`}
                                                    validate={(value) => {
                                                      if (
                                                        values.payment[index]
                                                          .installment_4
                                                      ) {
                                                        if (value?.length < 1) {
                                                          return "This field is required";
                                                        }
                                                      }
                                                    }}
                                                    render={({ field }) => (
                                                      <TextField
                                                        required
                                                        sx={{ m: 1 }}
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                        InputProps={{
                                                          startAdornment: (
                                                            <InputAdornment position="start">
                                                              %
                                                            </InputAdornment>
                                                          ),
                                                        }}
                                                        label="Markup Rate (Installment)"
                                                        id={`payment.${index}.markup_rate_installment`}
                                                        name={`payment.${index}.markup_rate_installment`}
                                                        value={values.payment[index].markup_rate_installment}
                                                        onChange={(e) => {
                                                          handleChange(e);
                                                        }}
                                                        error={Boolean(
                                                          touched.payment &&
                                                          touched?.payment[index]
                                                            ?.markup_rate_installment &&
                                                          errors.payment &&
                                                          errors?.payment[index]?.markup_rate_installment
                                                        )}
                                                        helperText={
                                                          touched.payment &&
                                                          touched?.payment[index]?.markup_rate_installment &&
                                                          errors.payment &&
                                                          errors?.payment[index]?.markup_rate_installment
                                                        }
                                                        variant="standard"
                                                        type="number"
                                                      />
                                                    )}
                                                  />
                                                </Grid>
                                              </>
                                            )
                                          }
                                        </Grid>
                                      )}

                                    {selectedPaymentHosts[index] &&
                                      showWorldPayDynamicField(
                                        selectedPaymentHosts[index]
                                      ) && (
                                        <Grid
                                          container
                                          column={6}
                                          alignItems="flex-end"
                                        >
                                          <Grid item xs={3}>
                                            <FormControlLabel
                                              sx={{ m: 1 }}
                                              type="checkbox"
                                              id={`payment.${index}.enable_vis`}
                                              name={`payment.${index}.enable_vis`}
                                              checked={
                                                values.payment[index].enable_vis
                                              }
                                              onChange={() =>
                                                setFieldValue(
                                                  `payment.${index}.enable_vis`,
                                                  !values.payment[index]
                                                    .enable_vis
                                                )
                                              }
                                              control={<Checkbox />}
                                              label="Enable VIS"
                                            />
                                          </Grid>
                                          <Grid item xs={4}>
                                            <FormControlLabel
                                              sx={{ m: 1 }}
                                              type="checkbox"
                                              id={`payment.${index}.default_bin_routing`}
                                              name={`payment.${index}.default_bin_routing`}
                                              checked={
                                                values.payment[index]
                                                  .default_bin_routing
                                              }
                                              onChange={() =>
                                                setFieldValue(
                                                  `payment.${index}.default_bin_routing`,
                                                  !values.payment[index]
                                                    .default_bin_routing
                                                )
                                              }
                                              control={<Checkbox />}
                                              label="Default Bin Routing"
                                            />
                                          </Grid>
                                        </Grid>
                                      )}

                                    {/* Begin Nomu */}
                                    {selectedPaymentHosts[index] &&
                                      showNomuPayDynamicField(
                                        selectedPaymentHosts[index]
                                      ) && (
                                        <Grid container column={6} alignItems="center">
                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.processing_account_id`}
                                              id={`payment.${index}.processing_account_id`}
                                              validate={(value) => {
                                                if (value?.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.processing_account_id`}
                                                  name={`payment.${index}.processing_account_id`}
                                                  label="Processing Account Id"
                                                  value={
                                                    values.payment[index].processing_account_id
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.processing_account_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.processing_account_id
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.processing_account_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.processing_account_id
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={4}>
                                            <FormControlLabel
                                              sx={{ m: 1 }}
                                              type="checkbox"
                                              id={`payment.${index}.default_bin_routing`}
                                              name={`payment.${index}.default_bin_routing`}
                                              checked={
                                                values.payment[index]
                                                  .default_bin_routing
                                              }
                                              onChange={() =>
                                                setFieldValue(
                                                  `payment.${index}.default_bin_routing`,
                                                  !values.payment[index]
                                                    .default_bin_routing
                                                )
                                              }
                                              control={<Checkbox />}
                                              label="Default Bin Routing"
                                            />
                                          </Grid>

                                          {!values.payment[index]
                                            .default_bin_routing && (
                                              <>
                                                <Grid item xs={2}>
                                                  <Field
                                                    name={`payment.${index}.min_card_range`}
                                                    id={`payment.${index}.min_card_range`}
                                                    validate={(value) => {
                                                      if (!value || value.length < 1) {
                                                        return "This field is required";
                                                      }
                                                    }}
                                                    render={({ field }) => (
                                                      <TextField
                                                        required
                                                        sx={{ m: 1 }}
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                        // InputProps={{
                                                        //   startAdornment: (
                                                        //     <InputAdornment position="start">
                                                        //       $
                                                        //     </InputAdornment>
                                                        //   ),
                                                        // }}
                                                        label="Min Card Range"
                                                        id={`payment.${index}.min_card_range`}
                                                        name={`payment.${index}.min_card_range`}
                                                        value={
                                                          values.payment[index]
                                                            .min_card_range
                                                        }
                                                        onChange={(e) => {
                                                          handleChange(e);
                                                        }}
                                                        error={Boolean(
                                                          touched.payment &&
                                                          touched?.payment[index]
                                                            ?.min_card_range &&
                                                          errors.payment &&
                                                          errors?.payment[index]
                                                            ?.min_card_range
                                                        )}
                                                        helperText={
                                                          touched.payment &&
                                                          touched.payment[index]
                                                            ?.min_card_range &&
                                                          errors.payment &&
                                                          errors?.payment[index]
                                                            ?.min_card_range
                                                        }
                                                        variant="standard"
                                                      />
                                                    )}
                                                  />
                                                </Grid>
                                                <Grid item xs={2}>
                                                  <Field
                                                    name={`payment.${index}.max_card_range`}
                                                    id={`payment.${index}.max_card_range`}
                                                    validate={(value) => {
                                                      if (value?.length < 1) {
                                                        return "This field is required";
                                                      }
                                                    }}
                                                    render={({ field }) => (
                                                      <TextField
                                                        required
                                                        sx={{ m: 1 }}
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                        // InputProps={{
                                                        //   startAdornment: (
                                                        //     <InputAdornment position="start">
                                                        //       $
                                                        //     </InputAdornment>
                                                        //   ),
                                                        // }}
                                                        label="Max Card Range"
                                                        id={`payment.${index}.max_card_range`}
                                                        name={`payment.${index}.max_card_range`}
                                                        value={
                                                          values.payment[index]
                                                            .max_card_range
                                                        }
                                                        onChange={(e) => {
                                                          handleChange(e);
                                                        }}
                                                        error={Boolean(
                                                          touched.payment &&
                                                          touched?.payment[index]
                                                            ?.max_card_range &&
                                                          errors.payment &&
                                                          errors?.payment[index]
                                                            ?.max_card_range
                                                        )}
                                                        helperText={
                                                          touched.payment &&
                                                          touched?.payment[index]
                                                            ?.max_card_range &&
                                                          errors.payment &&
                                                          errors?.payment[index]
                                                            ?.max_card_range
                                                        }
                                                        variant="standard"
                                                      />
                                                    )}
                                                  />
                                                </Grid>
                                              </>
                                            )}

                                        </Grid>
                                      )
                                      //end Nomu
                                    }

                                    {/* Begin Razer */}
                                    {selectedPaymentHosts[index] &&
                                      showRazerDynamicField(
                                        selectedPaymentHosts[index]
                                      ) && (
                                        <Grid container column={6} alignItems="center">
                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.secret_key`}
                                              id={`payment.${index}.secret_key`}
                                              validate={(value) => {
                                                if (value?.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.secret_key`}
                                                  name={`payment.${index}.secret_key`}
                                                  label="Secret Key"
                                                  value={
                                                    values?.payment[index]?.secret_key
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.secret_key &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.secret_key
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.secret_key &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.secret_key
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.verification_key`}
                                              id={`payment.${index}.verification_key`}
                                              validate={(value) => {
                                                if (value?.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.verification_key`}
                                                  name={`payment.${index}.verification_key`}
                                                  label="Verification Key"
                                                  value={
                                                    values.payment[index].verification_key
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.verification_key &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.verification_key
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.verification_key &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.verification_key
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.merchant_id`}
                                              id={`payment.${index}.merchant_id`}
                                              validate={(value) => {
                                                if (value?.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.merchant_id`}
                                                  name={`payment.${index}.merchant_id`}
                                                  label="Merchant id"
                                                  value={
                                                    values.payment[index].merchant_id
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.merchant_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.merchant_id
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.merchant_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.merchant_id
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.channel`}
                                              id={`payment.${index}.channel`}
                                              validate={(value) => {
                                                if (value?.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.channel`}
                                                  name={`payment.${index}.channel`}
                                                  label="Channel"
                                                  value={
                                                    values.payment[index].channel
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.channel &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.channel
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.channel &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.channel
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>
                                        </Grid>
                                      )
                                      //end Razer
                                    }

                                    {/* Begin Fiuu */}
                                    {selectedPaymentHosts[index] &&
                                      showFiuuDynamicField(
                                        selectedPaymentHosts[index]
                                      ) && (
                                        <Grid container column={6} alignItems="center">
                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.secret_key`}
                                              id={`payment.${index}.secret_key`}
                                              validate={(value) => {
                                                if (value?.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.secret_key`}
                                                  name={`payment.${index}.secret_key`}
                                                  label="Secret Key"
                                                  value={
                                                    values.payment[index].secret_key
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.secret_key &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.secret_key
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.secret_key &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.secret_key
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.merchant_id`}
                                              id={`payment.${index}.merchant_id`}
                                              validate={(value) => {
                                                if (value?.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.merchant_id`}
                                                  name={`payment.${index}.merchant_id`}
                                                  label="Merchant id"
                                                  value={
                                                    values.payment[index].merchant_id
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.merchant_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.merchant_id
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.merchant_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.merchant_id
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.terminal_id`}
                                              id={`payment.${index}.terminal_id`}
                                              render={({ field }) => (
                                                <TextField
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.terminal_id`}
                                                  name={`payment.${index}.terminal_id`}
                                                  label="Terminal ID"
                                                  value={
                                                    values.payment[index].terminal_id
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.terminal_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.terminal_id
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.terminal_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.terminal_id
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>
                                        </Grid>
                                      )
                                      //end Fiuu
                                    }

                                    {/* Begin Allinpay */}
                                    <AllinpayFields
                                      index={index}
                                      values={values}
                                      handleChange={handleChange}
                                      touched={touched}
                                      errors={errors}
                                      selectedPaymentHost={selectedPaymentHosts[index]}
                                      section="identifiers"
                                    />
                                    {/* End Allinpay */}
                                    {/* Begin Shopback */}
                                    {selectedPaymentHosts[index] &&
                                      showShopbackDynamicField(
                                        selectedPaymentHosts[index]
                                      ) && (
                                        <Grid container column={6} alignItems="center">
                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.access_key_id`}
                                              id={`payment.${index}.access_key_id`}
                                              validate={(value) => {
                                                if (value?.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.access_key_id`}
                                                  name={`payment.${index}.access_key_id`}
                                                  label="Access Key ID"
                                                  value={
                                                    values.payment[index].access_key_id
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.access_key_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.access_key_id
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.access_key_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.access_key_id
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.access_key_secret`}
                                              id={`payment.${index}.access_key_secret`}
                                              validate={(value) => {
                                                if (value?.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.access_key_secret`}
                                                  name={`payment.${index}.access_key_secret`}
                                                  label="Access Key Secret"
                                                  value={
                                                    values.payment[index].access_key_secret
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.access_key_secret &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.access_key_secret
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.access_key_secret &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.access_key_secret
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.pos_id`}
                                              id={`payment.${index}.pos_id`}
                                              validate={(value) => {
                                                if (!value || value.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.pos_id`}
                                                  name={`payment.${index}.pos_id`}
                                                  label="POS ID"
                                                  value={
                                                    values.payment[index].pos_id
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.pos_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.pos_id
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.pos_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.pos_id
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>
                                        </Grid>
                                      )
                                      //end Shopback
                                    }

                                    {/* Begin Nets */}
                                    {selectedPaymentHosts[index] &&
                                      showNetsDynamicField(
                                        selectedPaymentHosts[index]
                                      ) && (
                                        <Grid container column={6} alignItems="center">
                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.secret_id`}
                                              id={`payment.${index}.secret_id`}
                                              validate={(value) => {
                                                if (!value || value.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.secret_id`}
                                                  name={`payment.${index}.secret_id`}
                                                  label="SecretID"
                                                  value={
                                                    values.payment[index].secret_id
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.secret_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.secret_id
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.secret_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.secret_id
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.key_id`}
                                              id={`payment.${index}.key_id`}
                                              validate={(value) => {
                                                if (!value || value.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.key_id`}
                                                  name={`payment.${index}.key_id`}
                                                  label="KeyID"
                                                  value={
                                                    values.payment[index].key_id
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.key_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.key_id
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.key_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.key_id
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.mid`}
                                              id={`payment.${index}.mid`}
                                              validate={(value) => {
                                                if (!value || value.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.mid`}
                                                  name={`payment.${index}.mid`}
                                                  label="MID"
                                                  value={
                                                    values.payment[index].mid
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.mid &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.mid
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.mid &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.mid
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.tid`}
                                              id={`payment.${index}.tid`}
                                              validate={(value) => {
                                                if (!value || value.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.tid`}
                                                  name={`payment.${index}.tid`}
                                                  label="TID"
                                                  value={
                                                    values.payment[index].tid
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.tid &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.tid
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.tid &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.tid
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>
                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.institution_code`}
                                              id={`payment.${index}.institution_code`}
                                              validate={(value) => {
                                                if (!value || value.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.institution_code`}
                                                  name={`payment.${index}.institution_code`}
                                                  label="InstitutionCode"
                                                  value={
                                                    values.payment[index].institution_code
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.institution_code &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.institution_code
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.institution_code &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.institution_code
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>
                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.condition_code`}
                                              id={`payment.${index}.condition_code`}
                                              validate={(value) => {
                                                if (!value || value.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.condition_code`}
                                                  name={`payment.${index}.condition_code`}
                                                  label="Condition Code"
                                                  value={
                                                    values.payment[index].condition_code
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.condition_code &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.condition_code
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.condition_code &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.condition_code
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>
                                        </Grid>
                                      )
                                      //end Nets
                                    }

                                    {/* Begin host_fiuu */}
                                    {selectedPaymentHosts[index] &&
                                      showHostFiuuDynamicField(
                                        selectedPaymentHosts[index]
                                      ) && (
                                        <Grid container column={6} alignItems="center">
                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.host_fiuu_mid`}
                                              id={`payment.${index}.host_fiuu_mid`}
                                              validate={(value) => {
                                                if (value?.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.host_fiuu_mid`}
                                                  name={`payment.${index}.host_fiuu_mid`}
                                                  label="MID"
                                                  value={
                                                    values.payment[index].host_fiuu_mid
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.host_fiuu_mid &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.host_fiuu_mid
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.host_fiuu_mid &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.host_fiuu_mid
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.host_fiuu_verify_key`}
                                              id={`payment.${index}.host_fiuu_verify_key`}
                                              validate={(value) => {
                                                if (value?.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.host_fiuu_verify_key`}
                                                  name={`payment.${index}.host_fiuu_verify_key`}
                                                  label="Verify Key"
                                                  value={
                                                    values.payment[index].host_fiuu_verify_key
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.host_fiuu_verify_key &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.host_fiuu_verify_key
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.host_fiuu_verify_key &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.host_fiuu_verify_key
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.host_fiuu_secret_key`}
                                              id={`payment.${index}.host_fiuu_secret_key`}
                                              validate={(value) => {
                                                if (!value || value.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.host_fiuu_secret_key`}
                                                  name={`payment.${index}.host_fiuu_secret_key`}
                                                  label="Secret Key"
                                                  value={
                                                    values.payment[index].host_fiuu_secret_key
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.host_fiuu_secret_key &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.host_fiuu_secret_key
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.host_fiuu_secret_key &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.host_fiuu_secret_key
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>
                                          {/* <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.host_fiuu_email`}
                                              id={`payment.${index}.host_fiuu_email`}
                                              validate={(value) => {
                                                if (!value || value.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.host_fiuu_email`}
                                                  name={`payment.${index}.host_fiuu_email`}
                                                  label="Email"
                                                  value={
                                                    values.payment[index].host_fiuu_email
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.host_fiuu_email &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.host_fiuu_email
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.host_fiuu_email &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.host_fiuu_email
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid> */}
                                          {/* <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.host_fiuu_password`}
                                              id={`payment.${index}.host_fiuu_password`}
                                              validate={(value) => {
                                                if (!value || value.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.host_fiuu_password`}
                                                  name={`payment.${index}.host_fiuu_password`}
                                                  label="Password"
                                                  value={
                                                    values.payment[index].host_fiuu_password
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.host_fiuu_password &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.host_fiuu_password
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.password &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.host_fiuu_password
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid> */}
                                        </Grid>
                                      )
                                      //end host_fiuu
                                    }

                                    {/* Begin Cybersource */}
                                    {selectedPaymentHosts[index] &&
                                      showCybersourceDynamicField(
                                        selectedPaymentHosts[index]
                                      ) && (
                                        <>
                                          <Grid container column={6} alignItems="center">
                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.cybs_merchant_id`}
                                                id={`payment.${index}.cybs_merchant_id`}
                                                validate={(value) => {
                                                  if (value?.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.cybs_merchant_id`}
                                                    name={`payment.${index}.cybs_merchant_id`}
                                                    label="Merchant ID"
                                                    value={
                                                      values.payment[index].cybs_merchant_id
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.cybs_merchant_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.cybs_merchant_id
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.cybs_merchant_id &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.cybs_merchant_id
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>

                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.cybs_merchant_keyid`}
                                                id={`payment.${index}.cybs_merchant_keyid`}
                                                validate={(value) => {
                                                  if (value?.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.cybs_merchant_keyid`}
                                                    name={`payment.${index}.cybs_merchant_keyid`}
                                                    label="Key ID"
                                                    value={
                                                      values.payment[index].cybs_merchant_keyid
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.cybs_merchant_keyid &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.cybs_merchant_keyid
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.cybs_merchant_keyid &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.cybs_merchant_keyid
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>

                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.cybs_merchant_secretkey`}
                                                id={`payment.${index}.cybs_merchant_secretkey`}
                                                validate={(value) => {
                                                  if (!value || value.length < 1) {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id={`payment.${index}.cybs_merchant_secretkey`}
                                                    name={`payment.${index}.cybs_merchant_secretkey`}
                                                    label="Secret Key"
                                                    value={
                                                      values.payment[index].cybs_merchant_secretkey
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.cybs_merchant_secretkey &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.cybs_merchant_secretkey
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.cybs_merchant_secretkey &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.cybs_merchant_secretkey
                                                    }
                                                    variant="standard"
                                                  />
                                                )}
                                              />
                                            </Grid>

                                            <Grid item xs={2}>
                                              <Field
                                                name={`payment.${index}.cybs_mpi_type`}
                                                id={`payment.${index}.cybs_mpi_type`}
                                                validate={(value) => {
                                                  if (value === undefined || value === null || value === "") {
                                                    return "This field is required";
                                                  }
                                                }}
                                                render={({ field }) => (
                                                  <TextField
                                                    required
                                                    sx={{ m: 1 }}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    select
                                                    label="MPI Type"
                                                    id={`payment.${index}.cybs_mpi_type`}
                                                    name={`payment.${index}.cybs_mpi_type`}
                                                    value={
                                                      values.payment[index].cybs_mpi_type !== undefined
                                                        ? values.payment[index].cybs_mpi_type
                                                        : 0
                                                    }
                                                    onChange={handleChange}
                                                    error={Boolean(
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.cybs_mpi_type &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.cybs_mpi_type
                                                    )}
                                                    helperText={
                                                      touched.payment &&
                                                      touched?.payment[index]
                                                        ?.cybs_mpi_type &&
                                                      errors.payment &&
                                                      errors?.payment[index]?.cybs_mpi_type
                                                    }
                                                    variant="standard"
                                                  >
                                                    {MPI_TYPE_LIST.slice(0, 2).map((item) => (
                                                      <MenuItem key={item.id} value={item.id}>
                                                        {item.name}
                                                      </MenuItem>
                                                    )) || UnavailableOptionItem}
                                                  </TextField>
                                                )}
                                              />
                                            </Grid>
                                          </Grid>


                                          <Grid container column={6} alignItems="center" sx={{ mt: 2 }}>
                                            <Grid item xs={12}>
                                              <FormControlLabel
                                                control={
                                                  <Checkbox
                                                    checked={values.payment[index].ipp_enabled || false}
                                                    onChange={(e) => {
                                                      setFieldValue(`payment.${index}.ipp_enabled`, e.target.checked);
                                                      if (!e.target.checked) {
                                                        setFieldValue(`payment.${index}.ipp_plans`, []);
                                                      } else {
                                                        // Initialize with empty array if not exists
                                                        const currentPlans = values.payment[index].ipp_plans || [];
                                                        if (currentPlans.length === 0) {
                                                          setFieldValue(`payment.${index}.ipp_plans`, []);
                                                        }
                                                      }
                                                    }}
                                                  />
                                                }
                                                label="Installment payment plan"
                                              />
                                            </Grid>
                                          </Grid>

                                          {/* IPP Plans - Dynamic FieldArray */}
                                          {values.payment[index].ipp_enabled && (
                                            <FieldArray name={`payment.${index}.ipp_plans`}>
                                              {({ push, remove }) => (
                                                <Grid container spacing={2} sx={{ mt: 1, mb: 2 }}>
                                                  {values.payment[index].ipp_plans?.map((plan, planIndex) => (
                                                    <Grid item xs={12} key={planIndex}>
                                                      <Card sx={{ p: 2, border: '1px solid #e0e0e0' }}>
                                                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                                                          <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                                                            Plan {planIndex + 1}
                                                          </Typography>
                                                          <Button
                                                            variant="outlined"
                                                            color="error"
                                                            size="small"
                                                            startIcon={<Close />}
                                                            onClick={() => remove(planIndex)}
                                                            disabled={isSubmitting}
                                                          >
                                                            Remove
                                                          </Button>
                                                        </Stack>
                                                        <Grid container spacing={2}>
                                                          <Grid item xs={12} sm={6} md={3}>
                                                            <Field
                                                              name={`payment.${index}.ipp_plans.${planIndex}.bank`}
                                                              validate={(value) => {
                                                                if (!value || value.length < 1) {
                                                                  return "This field is required";
                                                                }
                                                              }}
                                                              render={({ field }) => (
                                                                <TextField
                                                                  {...field}
                                                                  required
                                                                  fullWidth
                                                                  size="small"
                                                                  label="Bank"
                                                                  error={Boolean(
                                                                    touched.payment?.[index]?.ipp_plans?.[planIndex]?.bank &&
                                                                    errors.payment?.[index]?.ipp_plans?.[planIndex]?.bank
                                                                  )}
                                                                  helperText={
                                                                    touched.payment?.[index]?.ipp_plans?.[planIndex]?.bank &&
                                                                    errors.payment?.[index]?.ipp_plans?.[planIndex]?.bank
                                                                  }
                                                                  disabled={isSubmitting}
                                                                />
                                                              )}
                                                            />
                                                          </Grid>
                                                          <Grid item xs={12} sm={6} md={3}>
                                                            <Field
                                                              name={`payment.${index}.ipp_plans.${planIndex}.months`}
                                                              validate={(value) => {
                                                                if (!value || value === null || value === undefined || value === "") {
                                                                  return "This field is required";
                                                                }
                                                                if (isNaN(value) || Number(value) <= 0) {
                                                                  return "Must be a positive number";
                                                                }
                                                              }}
                                                              render={({ field }) => (
                                                                <TextField
                                                                  {...field}
                                                                  required
                                                                  fullWidth
                                                                  size="small"
                                                                  type="number"
                                                                  label="Months"
                                                                  error={Boolean(
                                                                    touched.payment?.[index]?.ipp_plans?.[planIndex]?.months &&
                                                                    errors.payment?.[index]?.ipp_plans?.[planIndex]?.months
                                                                  )}
                                                                  helperText={
                                                                    touched.payment?.[index]?.ipp_plans?.[planIndex]?.months &&
                                                                    errors.payment?.[index]?.ipp_plans?.[planIndex]?.months
                                                                  }
                                                                  disabled={isSubmitting}
                                                                />
                                                              )}
                                                            />
                                                          </Grid>
                                                          <Grid item xs={12} sm={6} md={3}>
                                                            <Field
                                                              name={`payment.${index}.ipp_plans.${planIndex}.ipp_merchant_id`}
                                                              validate={(value) => {
                                                                if (!value || value.length < 1) {
                                                                  return "This field is required";
                                                                }
                                                              }}
                                                              render={({ field }) => (
                                                                <TextField
                                                                  {...field}
                                                                  required
                                                                  fullWidth
                                                                  size="small"
                                                                  label="Merchant ID"
                                                                  error={Boolean(
                                                                    touched.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_id &&
                                                                    errors.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_id
                                                                  )}
                                                                  helperText={
                                                                    touched.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_id &&
                                                                    errors.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_id
                                                                  }
                                                                  disabled={isSubmitting}
                                                                />
                                                              )}
                                                            />
                                                          </Grid>
                                                          <Grid item xs={12} sm={6} md={3}>
                                                            <Field
                                                              name={`payment.${index}.ipp_plans.${planIndex}.ipp_merchant_keyid`}
                                                              validate={(value) => {
                                                                if (!value || value.length < 1) {
                                                                  return "This field is required";
                                                                }
                                                              }}
                                                              render={({ field }) => (
                                                                <TextField
                                                                  {...field}
                                                                  required
                                                                  fullWidth
                                                                  size="small"
                                                                  label="Merchant Key ID"
                                                                  error={Boolean(
                                                                    touched.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_keyid &&
                                                                    errors.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_keyid
                                                                  )}
                                                                  helperText={
                                                                    touched.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_keyid &&
                                                                    errors.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_keyid
                                                                  }
                                                                  disabled={isSubmitting}
                                                                />
                                                              )}
                                                            />
                                                          </Grid>
                                                          <Grid item xs={12} sm={6} md={3}>
                                                            <Field
                                                              name={`payment.${index}.ipp_plans.${planIndex}.ipp_merchant_secretkey`}
                                                              validate={(value) => {
                                                                if (!value || value.length < 1) {
                                                                  return "This field is required";
                                                                }
                                                              }}
                                                              render={({ field }) => (
                                                                <TextField
                                                                  {...field}
                                                                  required
                                                                  fullWidth
                                                                  size="small"
                                                                  type="password"
                                                                  label="Merchant Secret Key"
                                                                  error={Boolean(
                                                                    touched.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_secretkey &&
                                                                    errors.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_secretkey
                                                                  )}
                                                                  helperText={
                                                                    touched.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_secretkey &&
                                                                    errors.payment?.[index]?.ipp_plans?.[planIndex]?.ipp_merchant_secretkey
                                                                  }
                                                                  disabled={isSubmitting}
                                                                />
                                                              )}
                                                            />
                                                          </Grid>
                                                        </Grid>
                                                      </Card>
                                                    </Grid>
                                                  ))}
                                                  <Grid item xs={12}>
                                                    <Button
                                                      variant="outlined"
                                                      startIcon={<AddCircleOutlined />}
                                                      onClick={() => push({ bank: '', months: '', ipp_merchant_id: '', ipp_merchant_keyid: '', ipp_merchant_secretkey: '' })}
                                                      disabled={isSubmitting}
                                                      sx={{ mt: 1 }}
                                                    >
                                                      Add Plan
                                                    </Button>
                                                  </Grid>
                                                </Grid>
                                              )}
                                            </FieldArray>
                                          )}
                                        </>
                                      )
                                      //end Cybersource
                                    }

                                    {/* Begin Dci */}
                                    {selectedPaymentHosts?.[index]?.toLowerCase().startsWith(PAYMENT_HOST_LIST.DCI) && (
                                      <Grid container column={6} alignItems="center">
                                        <Grid item xs={2}>
                                          <Field
                                            name={`payment.${index}.acquiring_institution_id`}
                                            id={`payment.${index}.acquiring_institution_id`}
                                            validate={(value) => {
                                              if (value?.length < 1) {
                                                return "This field is required";
                                              }
                                            }}
                                            render={({ field }) => (
                                              <TextField
                                                required
                                                sx={{ m: 1 }}
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                id={`payment.${index}.acquiring_institution_id`}
                                                name={`payment.${index}.acquiring_institution_id`}
                                                label="Acquiring Institution Id"
                                                value={
                                                  values.payment[index].acquiring_institution_id
                                                }
                                                onChange={(e) => {
                                                  handleChange(e);
                                                }}
                                                error={Boolean(
                                                  touched.payment &&
                                                  touched?.payment[index]
                                                    ?.acquiring_institution_id &&
                                                  errors.payment &&
                                                  errors?.payment[index]?.acquiring_institution_id
                                                )}
                                                helperText={
                                                  touched.payment &&
                                                  touched?.payment[index]
                                                    ?.acquiring_institution_id &&
                                                  errors.payment &&
                                                  errors?.payment[index]?.acquiring_institution_id
                                                }
                                                variant="standard"
                                              />
                                            )}
                                          />
                                        </Grid>

                                        <Grid item xs={2}>
                                          <Field
                                            name={`payment.${index}.forwarding_institution_id`}
                                            id={`payment.${index}.forwarding_institution_id`}
                                            validate={(value) => {
                                              if (value?.length < 1) {
                                                return "This field is required";
                                              }
                                            }}
                                            render={({ field }) => (
                                              <TextField
                                                required
                                                sx={{ m: 1 }}
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                id={`payment.${index}.forwarding_institution_id`}
                                                name={`payment.${index}.forwarding_institution_id`}
                                                label="Forwarding Institution Id"
                                                value={
                                                  values.payment[index].forwarding_institution_id
                                                }
                                                onChange={(e) => {
                                                  handleChange(e);
                                                }}
                                                error={Boolean(
                                                  touched.payment &&
                                                  touched?.payment[index]
                                                    ?.forwarding_institution_id &&
                                                  errors.payment &&
                                                  errors?.payment[index]?.forwarding_institution_id
                                                )}
                                                helperText={
                                                  touched.payment &&
                                                  touched?.payment[index]
                                                    ?.forwarding_institution_id &&
                                                  errors.payment &&
                                                  errors?.payment[index]?.forwarding_institution_id
                                                }
                                                variant="standard"
                                              />
                                            )}
                                          />
                                        </Grid>

                                        <Grid item xs={2}>
                                          <Field
                                            name={`payment.${index}.acceptor_id`}
                                            id={`payment.${index}.acceptor_id`}
                                            validate={(value) => {
                                              if (value?.length < 1) {
                                                return "This field is required";
                                              }
                                            }}
                                            render={({ field }) => (
                                              <TextField
                                                required
                                                sx={{ m: 1 }}
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                id={`payment.${index}.acceptor_id`}
                                                name={`payment.${index}.acceptor_id`}
                                                label="Acceptor Id"
                                                value={
                                                  values.payment[index].acceptor_id
                                                }
                                                onChange={(e) => {
                                                  handleChange(e);
                                                }}
                                                error={Boolean(
                                                  touched.payment &&
                                                  touched?.payment[index]
                                                    ?.acceptor_id &&
                                                  errors.payment &&
                                                  errors?.payment[index]?.acceptor_id
                                                )}
                                                helperText={
                                                  touched.payment &&
                                                  touched?.payment[index]
                                                    ?.acceptor_id &&
                                                  errors.payment &&
                                                  errors?.payment[index]?.acceptor_id
                                                }
                                                variant="standard"
                                              />
                                            )}
                                          />
                                        </Grid>

                                        <Grid item xs={2}>
                                          <Field
                                            name={`payment.${index}.processing_code`}
                                            id={`payment.${index}.processing_code`}
                                            validate={(value) => {
                                              if (value?.length < 1) {
                                                return "This field is required";
                                              }
                                            }}
                                            render={({ field }) => (
                                              <TextField
                                                required
                                                sx={{ m: 1 }}
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                id={`payment.${index}.processing_code`}
                                                name={`payment.${index}.processing_code`}
                                                label="Processing Code"
                                                value={
                                                  values.payment[index].processing_code
                                                }
                                                onChange={(e) => {
                                                  handleChange(e);
                                                }}
                                                error={Boolean(
                                                  touched.payment &&
                                                  touched?.payment[index]
                                                    ?.processing_code &&
                                                  errors.payment &&
                                                  errors?.payment[index]?.processing_code
                                                )}
                                                helperText={
                                                  touched.payment &&
                                                  touched?.payment[index]
                                                    ?.processing_code &&
                                                  errors.payment &&
                                                  errors?.payment[index]?.processing_code
                                                }
                                                variant="standard"
                                              />
                                            )}
                                          />
                                        </Grid>

                                        <Grid item xs={2}>
                                          <Field
                                            name={`payment.${index}.dci_descriptor`}
                                            id={`payment.${index}.dci_descriptor`}
                                            validate={(value) => {
                                              if (value?.length > 36) {
                                                return "This field cannot exceed 36 characters.";
                                              }
                                            }}
                                            render={({ field }) => (
                                              <TextField
                                                sx={{ m: 1 }}
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                id={`payment.${index}.dci_descriptor`}
                                                name={`payment.${index}.dci_descriptor`}
                                                label="DCI Descriptor"
                                                value={
                                                  values.payment[index].dci_descriptor
                                                }
                                                onChange={(e) => {
                                                  handleChange(e);
                                                }}
                                                error={Boolean(
                                                  touched.payment &&
                                                  touched?.payment[index]
                                                    ?.dci_descriptor &&
                                                  errors.payment &&
                                                  errors?.payment[index]?.dci_descriptor
                                                )}
                                                helperText={
                                                  touched.payment &&
                                                  touched?.payment[index]
                                                    ?.dci_descriptor &&
                                                  errors.payment &&
                                                  errors?.payment[index]?.dci_descriptor
                                                }
                                                variant="standard"
                                              />
                                            )}
                                          />
                                        </Grid>
                                      </Grid>
                                    )
                                      //end Dci
                                    }

                                    {/* Begin RevPay */}
                                    {selectedPaymentHosts[index] &&
                                      showRevPayDynamicField(
                                        selectedPaymentHosts[index]
                                      ) && (
                                        <Grid container column={6} alignItems="center">
                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.revpay_merchant_id`}
                                              id={`payment.${index}.revpay_merchant_id`}
                                              validate={(value) => {
                                                if (!value || value.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.revpay_merchant_id`}
                                                  name={`payment.${index}.revpay_merchant_id`}
                                                  label="RevPay Merchant ID"
                                                  value={
                                                    values.payment[index].revpay_merchant_id
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.revpay_merchant_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.revpay_merchant_id
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.revpay_merchant_id &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.revpay_merchant_id
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>
                                        </Grid>
                                      )
                                      //end RevPay
                                    }

                                    {/* Rate Fields (shopeepay-my) */}
                                    {selectedPaymentHosts[index] && showShopeePayMYDynamicField(selectedPaymentHosts[index]) && (
                                    <Grid item xs={12}>
                                      <Grid container spacing={2} alignItems="flex-end">

                                        {/* Rate fields */}
                                        <Grid item xs={12}>
                                          <Box sx={{ mt: 1, ml: 1 }}>
                                            <Grid container spacing={2}>
                                              <Grid item xs={3}>
                                                <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                  InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                  type="text" label="MY Merchant Ext ID" name={`payment.${index}.my_merchant_ext_id`}
                                                  value={values.payment[index].my_merchant_ext_id} onChange={handleChange} variant="standard" />
                                              </Grid>
                                              <Grid item xs={3}>
                                                <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                  InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                  type="text" label="MY Store Ext ID" name={`payment.${index}.my_store_ext_id`}
                                                  value={values.payment[index].my_store_ext_id} onChange={handleChange} variant="standard" />
                                              </Grid>
                                            </Grid>

                                            <Grid container spacing={2}>
                                              <Grid item xs={3}>
                                                <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                  InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                  type="number" label="Convenience Fee Indicator" name={`payment.${index}.convenience_fee_indicator`}
                                                  value={values.payment[index].convenience_fee_indicator} onChange={handleChange} variant="standard" />
                                              </Grid>
                                              <Grid item xs={3}>
                                                <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                  InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                  type="number" label="Convenience Fee Fixed" name={`payment.${index}.convenience_fee_fixed`}
                                                  value={values.payment[index].convenience_fee_fixed} onChange={handleChange} variant="standard" />
                                              </Grid>
                                              <Grid item xs={3}>
                                                <TextField fullWidth sx={{ m: 1 }} InputLabelProps={{ shrink: true }}
                                                  InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
                                                  type="number" label="Convenience Fee Percentage" name={`payment.${index}.convenience_fee_percentage`}
                                                  value={values.payment[index].convenience_fee_percentage} onChange={handleChange} variant="standard" />
                                              </Grid>
                                            </Grid>

                                            {/* AutoDebit fields */}
                                            <Grid container spacing={2}>
                                              <Grid item xs={2}>
                                                <Field
                                                  name={`payment.${index}.is_autodebit_enabled`}
                                                  id={`payment.${index}.is_autodebit_enabled`}
                                                  render={({ field }) => (
                                                    <FormControlLabel
                                                      sx={{ m: 1 }}
                                                      control={
                                                        <Checkbox
                                                          id={`payment.${index}.is_autodebit_enabled`}
                                                          name={`payment.${index}.is_autodebit_enabled`}
                                                          checked={Boolean(
                                                            values.payment[index].is_autodebit_enabled
                                                          )}
                                                          onChange={(e) => {
                                                            setFieldValue(
                                                              `payment.${index}.is_autodebit_enabled`,
                                                              e.target.checked
                                                            );
                                                            if (!e.target.checked) {
                                                              setFieldValue(
                                                                `payment.${index}.autodebit_amount`,
                                                                ""
                                                              );
                                                            }
                                                          }}
                                                        />
                                                      }
                                                      label="Enable AutoDebit"
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              {values.payment[index].is_autodebit_enabled && (
                                                <Grid item xs={2}>
                                                  <Field
                                                    name={`payment.${index}.autodebit_amount`}
                                                    id={`payment.${index}.autodebit_amount`}
                                                    validate={(value) => {
                                                      if (
                                                        values.payment[index].is_autodebit_enabled &&
                                                        (value === undefined || value === null || value === "")
                                                      ) {
                                                        return "AutoDebit Amount is required";
                                                      }
                                                    }}
                                                    render={({ field }) => (
                                                      <TextField
                                                        required
                                                        sx={{ m: 1 }}
                                                        InputLabelProps={{ shrink: true }}
                                                        type="number"
                                                        label="AutoDebit Amount"
                                                        id={`payment.${index}.autodebit_amount`}
                                                        name={`payment.${index}.autodebit_amount`}
                                                        value={values.payment[index].autodebit_amount}
                                                        onChange={(e) => { handleChange(e); }}
                                                        error={Boolean(
                                                          touched.payment &&
                                                          touched?.payment[index]?.autodebit_amount &&
                                                          errors.payment &&
                                                          errors?.payment[index]?.autodebit_amount
                                                        )}
                                                        helperText={
                                                          touched.payment &&
                                                          touched?.payment[index]?.autodebit_amount &&
                                                          errors.payment &&
                                                          errors?.payment[index]?.autodebit_amount
                                                        }
                                                        variant="standard"
                                                      />
                                                    )}
                                                  />
                                                </Grid>
                                              )}
                                            </Grid>

                                          </Box>
                                        </Grid>

                                      </Grid>
                                    </Grid>
                                    )}

                                    {selectedPaymentHosts?.[index] === routeGw2[index]?.name && routeGw2[index]?.isRouteGw2 &&
                                      <Grid
                                        container
                                        column={12}
                                      >
                                        <>
                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.gw2_params.mcptid`}
                                              id={`payment.${index}.gw2_params.mcptid`}
                                              validate={(value) => {
                                                if (value?.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.gw2_params.mcptid`}
                                                  name={`payment.${index}.gw2_params.mcptid`}
                                                  label="MCPTID"
                                                  value={
                                                    values.payment[index]?.gw2_params?.mcptid
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.gw2_params?.mcptid &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.gw2_params?.mcptid
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.gw2_params?.mcptid &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.gw2_params?.mcptid
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={2}>
                                            <Field
                                              name={`payment.${index}.gw2_params.etype`}
                                              id={`payment.${index}.gw2_params.etype`}
                                              validate={(value) => {
                                                if (value?.length < 1) {
                                                  return "This field is required";
                                                }
                                              }}
                                              render={({ field }) => (
                                                <TextField
                                                  required
                                                  sx={{ m: 1 }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  id={`payment.${index}.gw2_params.etype`}
                                                  name={`payment.${index}.gw2_params.etype`}
                                                  label="EType"
                                                  value={
                                                    values.payment[index]?.gw2_params?.etype
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                  error={Boolean(
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.gw2_params?.etype &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.gw2_params?.etype
                                                  )}
                                                  helperText={
                                                    touched.payment &&
                                                    touched?.payment[index]
                                                      ?.gw2_params?.etype &&
                                                    errors.payment &&
                                                    errors?.payment[index]?.gw2_params?.etype
                                                  }
                                                  variant="standard"
                                                />
                                              )}
                                            />
                                          </Grid>
                                        </>

                                        <Grid item xs={4}>
                                          <FormControlLabel
                                            sx={{ m: 1 }}
                                            type="checkbox"
                                            id={`payment.${index}.route_enabled`}
                                            name={`payment.${index}.route_enabled`}
                                            checked={
                                              values.payment[index].route_enabled
                                            }
                                            onChange={() =>
                                              setFieldValue(
                                                `payment.${index}.route_enabled`,
                                                !values.payment[index].route_enabled
                                              )
                                            }
                                            control={<Checkbox />}
                                            label="Enable Route GW2"
                                          />
                                        </Grid>
                                      </Grid>
                                    }

                                  </Card>
                                ))}

                              <Button
                                onClick={() =>
                                  push({
                                    ...initialRow[0],
                                  })
                                }
                                variant="contained"
                                startIcon={<AddCircleOutlined />}
                                sx={{ m: 2, ...styles.customButton }}
                              >
                                Add New Route
                              </Button>
                            </Box>
                          )}
                        </FieldArray>
                      </Grid>
                    </Grid>
                  </Form>
                </FormDialog>
              );
            }}
          </Formik>
        </Box>
      </Container>
    );
  } else {
    return (
      <>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </>
    );
  }
};

export default EditDialog;
